export const fonts = [
  {
    fontFamily: "Merriweather",
    url: "Merriweather.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Fira-Sans",
    url: "Fira-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Noto-Serif",
    url: "Noto-Serif.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Roboto",
    url: "Roboto.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lato",
    url: "Lato.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lora",
    url: "Lora.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Montserrat",
    url: "Montserrat.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Mukta",
    url: "Mukta.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Nanum-Gothic",
    url: "Nanum-Gothic.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Noto-Sans",
    url: "Noto-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Noto-Sans-JP",
    url: "Noto-Sans-JP.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Noto-Sans-KR",
    url: "Noto-Sans-KR.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Noto-Sans-TC",
    url: "Noto-Sans-TC.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Nunito",
    url: "Nunito.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Nunito-Sans",
    url: "Nunito-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Open-Sans",
    url: "Open-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Oswald",
    url: "Oswald.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Playfair-Display",
    url: "Playfair-Display.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Poppins",
    url: "Poppins.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "PT-Sans",
    url: "PT-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "PT-Serif",
    url: "PT-Serif.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Roboto-Condensed",
    url: "Roboto-Condensed.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Roboto-Mono",
    url: "Roboto-Mono.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rubik",
    url: "Rubik.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Source-Sans-Pro",
    url: "Source-Sans-Pro.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Titillium-Web",
    url: "Titillium-Web.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Ubuntu",
    url: "Ubuntu.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Work-Sans",
    url: "Work-Sans.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Libre-Baskerville",
    url: "Libre-Baskerville.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Roboto-Slab",
    url: "Roboto-Slab.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "53 Symbols",
    url: "53Symbols-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Academy-Engraved-LET",
    url: "Academy-Engraved-LET.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Algerian",
    url: "Algerian.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "AltemusBordersFour-Regular",
    url: "AltemusBordersFour-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Amatic-SC",
    url: "Amatic-SC.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "American-Typewriter",
    url: "American-Typewriter.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "American-Typewriter-Bold",
    url: "American-Typewriter-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Antique-Book-Cover-Regular",
    url: "Antique-Book-Cover-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Arquitecta-Bold",
    url: "Arquitecta-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Atlas-Grotesk-Light",
    url: "Atlas-Grotesk-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Atlas-Grotesk-Regular",
    url: "Atlas-Grotesk-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Audrey-Normal",
    url: "Audrey-Normal.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-45-Book",
    url: "Avenir-LT-Std-45-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-45-Book-Italic",
    url: "Avenir-LT-Std-45-Book-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-45-Book",
    url: "Avenir-LT-Std-45-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-45-Book-Italic",
    url: "Avenir-LT-Std-45-Book-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-55-Roman",
    url: "Avenir-LT-Std-55-Roman.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Avenir-LT-Std-55-Roman-Italic",
    url: "Avenir-LT-Std-55-Roman-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "B52",
    url: "B52.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-Italic",
    url: "Baskerville-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-SemiBold",
    url: "Baskerville-SemiBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-SemiBoldItalic",
    url: "Baskerville-SemiBoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Baskerville",
    url: "Baskerville.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-Normal",
    url: "Baskerville-Normal.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-Normal-Italic",
    url: "Baskerville-Normal-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-Bold",
    url: "Baskerville-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Baskerville-BoldItalic",
    url: "Baskerville-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "BauerBodoni-LT-Black",
    url: "BauerBodoni-LT-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bebas-Neue-Regular",
    url: "Bebas-Neue-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bebas-Neue-Bold",
    url: "Bebas-Neue-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bebas-Neue-Light",
    url: "Bebas-Neue-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bebas-Neue-Book",
    url: "Bebas-Neue-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Beton-LT-Bold",
    url: "Beton-LT-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Beton-LT-Bold-Compress",
    url: "Beton-LT-Bold-Compress.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Beton-LT-Bold-Condensed",
    url: "Beton-LT-Bold-Condensed.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Beton-LT-Demi",
    url: "Beton-LT-Demi.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Beton-LT-Light",
    url: "Beton-LT-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Big-Caslon",
    url: "Big-Caslon.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Biscotti-Bold",
    url: "Biscotti-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Book-Antiqua",
    url: "Book-Antiqua.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Book-Antiqua-Bold",
    url: "Book-Antiqua-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Book-Antiqua-Italic",
    url: "Book-Antiqua-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Book-Antiqua-Bold-Italic",
    url: "Book-Antiqua-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Bookman-Old-Style",
    url: "Bookman-Old-Style.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bookman-Old-Style-Bold",
    url: "Bookman-Old-Style-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Bookman-Old-Style-Italic",
    url: "Bookman-Old-Style-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Bookman-Old-Style-Bold-Italic",
    url: "Bookman-Old-Style-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Bourgeois-Bold",
    url: "Bourgeois-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Browallia-New",
    url: "Browallia-New.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Browallia-New-Bold",
    url: "Browallia-New-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Browallia-New-Italic",
    url: "Browallia-New-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Browallia-New-Bold-Italic",
    url: "Browallia-New-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Brown-Bold",
    url: "Brown-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Brown-BoldItalic",
    url: "Brown-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Brown-Light",
    url: "Brown-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Brown-LightItalic",
    url: "Brown-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Brown-Regular",
    url: "Brown-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Brown-Italic",
    url: "Brown-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Brown-RegularItalic",
    url: "Brown-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Brush-Script-MT",
    url: "Brush-Script-MT.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Calibri",
    url: "Calibri.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Calibri-Bold",
    url: "Calibri-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Calibri-Italic",
    url: "Calibri-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Calibri-Bold-Italic",
    url: "Calibri-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Callie-Hand",
    url: "Callie-Hand.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Canela-Regular",
    url: "Canela-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Canela-RegularItalic",
    url: "Canela-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Canela-Thin",
    url: "Canela-Thin.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Canela-ThinItalic",
    url: "Canela-ThinItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Capitals",
    url: "Capitals.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Carrosserie-Med",
    url: "Carrosserie-Med.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CenturyGothic",
    url: "CenturyGothic.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CenturyOldStyle",
    url: "CenturyOldStyle.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CenturyOldStyle-Bold",
    url: "CenturyOldStyle-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Century-Schoolbook",
    url: "Century-Schoolbook.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Century-Schoolbook-Bold",
    url: "Century-Schoolbook-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Century-Schoolbook-Italic",
    url: "Century-Schoolbook-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Century-Schoolbook-Bold-Italic",
    url: "Century-Schoolbook-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Champagne-Limousines",
    url: "Champagne-Limousines.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Champagne-Limousines-Bold",
    url: "Champagne-Limousines-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Champagne-Limousines-Italic",
    url: "Champagne-Limousines-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Champagne-Limousines-BoldItalic",
    url: "Champagne-Limousines-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Cinzel",
    url: "Cinzel.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Cinzel-Bold",
    url: "Cinzel-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Cinzel-Black",
    url: "Cinzel-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Cinzel-Decorative",
    url: "Cinzel-Decorative.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Cinzel-Decorative-Black",
    url: "Cinzel-Decorative-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-ExtraLight",
    url: "CocoSharp-ExtraLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-ExtraLightItalic",
    url: "CocoSharp-ExtraLightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Light",
    url: "CocoSharp-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-LightItalic",
    url: "CocoSharp-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Regular",
    url: "CocoSharp-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Italic",
    url: "CocoSharp-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-BoldItalic",
    url: "CocoSharp-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Bold",
    url: "CocoSharp-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Extrabold",
    url: "CocoSharp-Extrabold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-ExtraboldItalic",
    url: "CocoSharp-ExtraboldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-Heavy",
    url: "CocoSharp-Heavy.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CocoSharp-HeavyItalic",
    url: "CocoSharp-HeavyItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Copperplate-Gothic-Bold",
    url: "Copperplate-Gothic-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Craw-Modern",
    url: "Craw-Modern.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CrawModURWReg",
    url: "CrawModURWReg.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "CrawModURWTBol",
    url: "CrawModURWTBol.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Didot",
    url: "Didot.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Didot-Bold",
    url: "Didot-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Didot-Italic",
    url: "Didot-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "DIN",
    url: "DIN.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Bold",
    url: "DIN-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Alternate",
    url: "DIN-Alternate.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Alternate-Bold",
    url: "DIN-Alternate-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Alternate-Black",
    url: "DIN-Alternate-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Alternate-Light",
    url: "DIN-Alternate-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Alternate-Medium",
    url: "DIN-Alternate-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Black",
    url: "DIN-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Light",
    url: "DIN-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DIN-Medium",
    url: "DIN-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "DTL-Documenta-Sans-TOT",
    url: "DTL-Documenta-Sans-TOT.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EdwardianScriptITC",
    url: "EdwardianScriptITC.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Elderkin-Bold",
    url: "Elderkin-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Elderkin-Bold",
    url: "Elderkin-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-Black",
    url: "EnglishGrotesque-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-Bold",
    url: "EnglishGrotesque-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-ExtraBold",
    url: "EnglishGrotesque-ExtraBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-Light",
    url: "EnglishGrotesque-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-Medium",
    url: "EnglishGrotesque-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EnglishGrotesque-Thin",
    url: "EnglishGrotesque-Thin.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Engravers-MT",
    url: "Engravers-MT.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EngraversGothic-BT",
    url: "EngraversGothic-BT.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Entypo",
    url: "Entypo.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-Light",
    url: "EuclidCircularB-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-LightItalic",
    url: "EuclidCircularB-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-Regular",
    url: "EuclidCircularB-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-RegularItalic",
    url: "EuclidCircularB-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-Bold",
    url: "EuclidCircularB-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-BoldItalic",
    url: "EuclidCircularB-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-Medium",
    url: "EuclidCircularB-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-MediumItalic",
    url: "EuclidCircularB-MediumItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-Semibold",
    url: "EuclidCircularB-Semibold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "EuclidCircularB-SemBdIta",
    url: "EuclidCircularB-SemBdIta.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Existence-Light2",
    url: "Existence-Light2.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Existence-Light",
    url: "Existence-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Existence-StencilLight",
    url: "Existence-StencilLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Existence-UnicaseLight",
    url: "Existence-UnicaseLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FavoritStd-MediumExtended",
    url: "FavoritStd-MediumExtended.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Fili-Script",
    url: "Fili-Script.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FilosofiaBold",
    url: "FilosofiaBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FilosofiaItalic",
    url: "FilosofiaItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FilosofiaRegular",
    url: "FilosofiaRegular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FilosofiaRegularLining",
    url: "FilosofiaRegularLining.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProLight-Regular",
    url: "FreightDispProLight-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProLight-Italic",
    url: "FreightDispProLight-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBook-Regular",
    url: "FreightDispProBook-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBook-Italic",
    url: "FreightDispProBook-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProMedium-Regular",
    url: "FreightDispProMedium-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProMedium-Italic",
    url: "FreightDispProMedium-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProSemibold-Regular",
    url: "FreightDispProSemibold-Regular.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProSemibold-Italic",
    url: "FreightDispProSemibold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBold-Regular",
    url: "FreightDispProBold-Regular.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBold-Italic",
    url: "FreightDispProBold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBlack-Regular",
    url: "FreightDispProBlack-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FreightDispProBlack-Italic",
    url: "FreightDispProBlack-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Futura-Bold",
    url: "Futura-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Bold-Oblique",
    url: "Futura-Bold-Oblique.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-ExtraBold",
    url: "Futura-ExtraBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-ExtraBold-Oblique",
    url: "Futura-ExtraBold-Oblique.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Light",
    url: "Futura-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Light-Oblique",
    url: "Futura-Light-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Medium",
    url: "Futura-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Medium-Oblique",
    url: "Futura-Medium-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Regular",
    url: "Futura-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Oblique",
    url: "Futura-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaBkBTBook-Italic",
    url: "FuturaBkBTBook-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Futura-Black",
    url: "Futura-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Black-Oblique",
    url: "Futura-Black-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaLtBT-Bold",
    url: "FuturaLtBT-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaLtBT-BoldItalic",
    url: "FuturaLtBT-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "FuturaLtBT-Light",
    url: "FuturaLtBT-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaLtBT-LightItalic",
    url: "FuturaLtBT-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Futura-No-2-D-DemiBold",
    url: "Futura-No-2-D-DemiBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-No-2-D-Medium",
    url: "Futura-No-2-D-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Futura-Std",
    url: "Futura-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaNo2SCD-Boo",
    url: "FuturaNo2SCD-Boo.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaT-Book",
    url: "FuturaT-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "FuturaTEE-Medi",
    url: "FuturaTEE-Medi.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Garamond",
    url: "Garamond.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Garamond-Bold",
    url: "Garamond-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Garamond-Italic",
    url: "Garamond-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Gill-Sans-MT-Pro-Light",
    url: "Gill-Sans-MT-Pro-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Gill-Sans-MT-Pro-Light-Italic",
    url: "Gill-Sans-MT-Pro-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Gill-Sans-Std",
    url: "Gill-Sans-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Gill-Sans-Std-Bold",
    url: "Gill-Sans-Std-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GoodHeadlineOffc-CondMedium",
    url: "GoodHeadlineOffc-CondMedium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GoodHeadlineScOffc-CondMedium",
    url: "GoodHeadlineScOffc-CondMedium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Goudy-Old-Style",
    url: "Goudy-Old-Style.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Goudy-Old-Style-Bold",
    url: "Goudy-Old-Style-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Goudy-Old-Style-Italic",
    url: "Goudy-Old-Style-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Gramercy-Gothic",
    url: "Gramercy-Gothic.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GrandSlang-B-Side",
    url: "GrandSlang-B-Side.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GrandSlang-Italic",
    url: "GrandSlang-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "GrandSlang-Roman",
    url: "GrandSlang-Roman.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GTAlpina-Rg",
    url: "GTAlpina-Rg.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "GTAlpina-Rg",
    url: "GTAlpina-Rg.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Haas-Grot-Text-55-Roman",
    url: "Haas-Grot-Text-55-Roman.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Haas-Grot-Text-75-Bold",
    url: "Haas-Grot-Text-75-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Handle-Oldstyle",
    url: "Handle-Oldstyle.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Harriet-Text-Light",
    url: "Harriet-Text-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Harriet-Text-LightItalic",
    url: "Harriet-Text-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Heebo-Regular",
    url: "Heebo-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Heebo-Light",
    url: "Heebo-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Heebo-Thin",
    url: "Heebo-Thin.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-Regular",
    url: "HeldaneText-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-RegularItalic",
    url: "HeldaneText-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-Bold",
    url: "HeldaneText-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-BoldItalic",
    url: "HeldaneText-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-Medium",
    url: "HeldaneText-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HeldaneText-MediumItalic",
    url: "HeldaneText-MediumItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Helvetica",
    url: "Helvetica.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-Bold",
    url: "Helvetica-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-BoldOblique",
    url: "Helvetica-BoldOblique.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-Light",
    url: "Helvetica-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-LightOblique",
    url: "Helvetica-LightOblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-Oblique",
    url: "Helvetica-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Helvetica-Neue-LT-Std",
    url: "Helvetica-Neue-LT-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HelveticaNeueLTStd45Light-Reg",
    url: "HelveticaNeueLTStd45Light-Reg.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HelveticaNeueLTStd46LightItal",
    url: "HelveticaNeueLTStd46LightItal.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "HiLo-Deco",
    url: "HiLo-Deco.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Hoefler-Text",
    url: "Hoefler-Text.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Hoefler-Text-Bold",
    url: "Hoefler-Text-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Hoefler-Text-Italic",
    url: "Hoefler-Text-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Hoefler-Text-Bold-Italic",
    url: "Hoefler-Text-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "I-Still-Believe",
    url: "I-Still-Believe.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "IM-FELL-DW-Pica-PRO",
    url: "IM-FELL-DW-Pica-PRO.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "IM-FELL-DW-Pica-PRO-Italic",
    url: "IM-FELL-DW-Pica-PRO-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "ITC-Century-Std-BookItalic",
    url: "ITC-Century-Std-BookItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "ITC-Kabel-Std-Book",
    url: "ITC-Kabel-Std-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Kabel-Std-Book-Demi",
    url: "ITC-Kabel-Std-Book-Demi.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Kabel-Std-Medium",
    url: "ITC-Kabel-Std-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Kabel-Std-Medium",
    url: "ITC-Kabel-Std-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Kabel-Std-Ultra",
    url: "ITC-Kabel-Std-Ultra.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Regular",
    url: "ITCVeljovicStdBook-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Bold",
    url: "ITCVeljovicStdBook-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Italic",
    url: "ITCVeljovicStdBook-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Knockout-HTF26-JuniorFlyweight",
    url: "Knockout-HTF26-JuniorFlyweight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Knockout-HTF27-JuniorBantamwt",
    url: "Knockout-HTF27-JuniorBantamwt.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Knockout-HTF28-JuniorFeatherwt",
    url: "Knockout-HTF28-JuniorFeatherwt.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Knockout-HTF29-JuniorLiteweight",
    url: "Knockout-HTF29-JuniorLiteweight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Knockout-HTF30-JuniorWelterwt",
    url: "Knockout-HTF30-JuniorWelterwt.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "L-Avenir-Light",
    url: "L-Avenir-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "L-Avenir-Light-Italic",
    url: "L-Avenir-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Lato-Hairline",
    url: "Lato-Hairline.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lato-HairlineItalic",
    url: "Lato-HairlineItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Lato-LightItalic",
    url: "Lato-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Lato-Black",
    url: "Lato-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lato-Black-Italic",
    url: "Lato-Black-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Lato-Bold",
    url: "Lato-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lato-Black2",
    url: "Lato-Black2.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lato-BlackItalic",
    url: "Lato-BlackItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "League-Gothic",
    url: "League-Gothic.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lucida-Bright",
    url: "Lucida-Bright.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lucida-Bright-Italic",
    url: "Lucida-Bright-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Lucida-Bright-Demi",
    url: "Lucida-Bright-Demi.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Lucida-Bright-Demi-Italic",
    url: "Lucida-Bright-Demi-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Marian-1812-Italic",
    url: "Marian-1812-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Minion-Pro-Regular",
    url: "Minion-Pro-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Monotype-Modern-Std",
    url: "Monotype-Modern-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Monotype-Modern-Std-Italic",
    url: "Monotype-Modern-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "MyriadPro-Regular",
    url: "MyriadPro-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "NanumMyeongjo",
    url: "NanumMyeongjo.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "NanumMyeongjoBold",
    url: "NanumMyeongjoBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "NanumMyeongjoExtraBold",
    url: "NanumMyeongjoExtraBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Display-Medium",
    url: "Neutra-Display-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Display-Bold",
    url: "Neutra-Display-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Text-Bold",
    url: "Neutra-Text-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Text-Bold-Italic",
    url: "Neutra-Text-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Text-Book",
    url: "Neutra-Text-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Neutra-Text-Book-Italic",
    url: "Neutra-Text-Book-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "ITC-Officina-Serif-Bold",
    url: "ITC-Officina-Serif-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Officina-Serif-Bold-Italic",
    url: "ITC-Officina-Serif-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "ITC-Officina-Serif-Book",
    url: "ITC-Officina-Serif-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "ITC-Officina-Serif-Book-Italic",
    url: "ITC-Officina-Serif-Book-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "P22Eaglefeather",
    url: "P22Eaglefeather.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "P22EaglefeatherBold",
    url: "P22EaglefeatherBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "P22EaglefeatherBoldItalic",
    url: "P22EaglefeatherBoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "P22EaglefeatherItalic",
    url: "P22EaglefeatherItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Perpetua",
    url: "Perpetua.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Perpetua-Bold",
    url: "Perpetua-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Perpetua-Italic",
    url: "Perpetua-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Perpetua-Bold-Italic",
    url: "Perpetua-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "PFEef-Regular",
    url: "PFEef-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Head-MT-Std-Light-Cn",
    url: "Plantin-Head-MT-Std-Light-Cn.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Head-MT-Std-Medium-Cn",
    url: "Plantin-Head-MT-Std-Medium-Cn.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Head-MT-Std-Bold-Cn",
    url: "Plantin-Head-MT-Std-Bold-Cn.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Infant-MT-Std",
    url: "Plantin-Infant-MT-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Infant-MT-Std-Italic",
    url: "Plantin-Infant-MT-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Infant-MT-Std-Bold",
    url: "Plantin-Infant-MT-Std-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Infant-MT-Std-Bold-It",
    url: "Plantin-Infant-MT-Std-Bold-It.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std",
    url: "Plantin-MT-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Italic",
    url: "Plantin-MT-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Bold",
    url: "Plantin-MT-Std-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Bold-Italic",
    url: "Plantin-MT-Std-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Light",
    url: "Plantin-MT-Std-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Light-Italic",
    url: "Plantin-MT-Std-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Semibold",
    url: "Plantin-MT-Std-Semibold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-MT-Std-Semibold-Italic",
    url: "Plantin-MT-Std-Semibold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Std-Bold-Condensed",
    url: "Plantin-Std-Bold-Condensed.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Plantin-Titling-MT-Std",
    url: "Plantin-Titling-MT-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Prata-Regular",
    url: "Prata-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-Bold",
    url: "Raleway-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-ExtraBold",
    url: "Raleway-ExtraBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-ExtraLight",
    url: "Raleway-ExtraLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-Heavy",
    url: "Raleway-Heavy.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-Light",
    url: "Raleway-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-Medium",
    url: "Raleway-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway",
    url: "Raleway.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-SemiBold",
    url: "Raleway-SemiBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Raleway-Thin",
    url: "Raleway-Thin.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "RobotoSlab-Bold",
    url: "RobotoSlab-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "RobotoSlab-Regular",
    url: "RobotoSlab-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "RobotoSlab-Light",
    url: "RobotoSlab-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "RobotoSlab-Thin",
    url: "RobotoSlab-Thin.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std",
    url: "Rockwell-Std.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Bold",
    url: "Rockwell-Std-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Bold-Condensed",
    url: "Rockwell-Std-Bold-Condensed.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Bold-Italic",
    url: "Rockwell-Std-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Condensed",
    url: "Rockwell-Std-Condensed.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Extra-Bold",
    url: "Rockwell-Std-Extra-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Italic",
    url: "Rockwell-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Light",
    url: "Rockwell-Std-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Rockwell-Std-Light-Italic",
    url: "Rockwell-Std-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Sackers-Gothic-Std-Heavy",
    url: "Sackers-Gothic-Std-Heavy.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sackers-Gothic-Std-Light",
    url: "Sackers-Gothic-Std-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sackers-Gothic-Medium",
    url: "Sackers-Gothic-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sackers-Gothic-Medium-Oblique",
    url: "Sackers-Gothic-Medium-Oblique.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "SaisonsSmartFont",
    url: "SaisonsSmartFont.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "SangBleuSans-Regular",
    url: "SangBleuSans-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "SangBleuSans-RegularItalic",
    url: "SangBleuSans-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "SangBleuSans-Bold",
    url: "SangBleuSans-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "SangBleuSans-Medium",
    url: "SangBleuSans-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sansumi",
    url: "Sansumi.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sansumi-Bold",
    url: "Sansumi-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-ExtraLight",
    url: "Seravek-ExtraLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-ExtraLightItalic",
    url: "Seravek-ExtraLightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Seravek-Light",
    url: "Seravek-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-LightItalic",
    url: "Seravek-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Seravek",
    url: "Seravek.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-Italic",
    url: "Seravek-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Seravek-BoldItalic",
    url: "Seravek-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Seravek-Bold",
    url: "Seravek-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-Medium",
    url: "Seravek-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Seravek-MediumItalic",
    url: "Seravek-MediumItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Sheila",
    url: "Sheila.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Sheila-Bold",
    url: "Sheila-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Snell-Roundhand",
    url: "Snell-Roundhand.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Snell-Roundhand-Bold",
    url: "Snell-Roundhand-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Snell-Roundhand-Black",
    url: "Snell-Roundhand-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Special-Elite",
    url: "Special-Elite.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Special-Elite-Bold",
    url: "Special-Elite-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Bold",
    url: "Superior-Title-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Bold-Italic",
    url: "Superior-Title-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Light",
    url: "Superior-Title-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Light-Italic",
    url: "Superior-Title-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Medium",
    url: "Superior-Title-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Medium-Italic",
    url: "Superior-Title-Medium-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Regular",
    url: "Superior-Title-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Regular-Italic",
    url: "Superior-Title-Regular-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Black",
    url: "Superior-Title-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Superior-Title-Black-Italic",
    url: "Superior-Title-Black-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Theano-Old-Style",
    url: "Theano-Old-Style.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Throw-My-Hands-Up-in-the-Air",
    url: "Throw-My-Hands-Up-in-the-Air.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Throw-My-Hands-Up-in-the-Air-Bold",
    url: "Throw-My-Hands-Up-in-the-Air-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Tiempos-Text-Regular",
    url: "Tiempos-Text-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Tiempos-Text-Regular-Italic",
    url: "Tiempos-Text-Regular-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "TradeGothic-LT-Light-Italic",
    url: "TradeGothic-LT-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Tungsten-Narrow-Medium",
    url: "Tungsten-Narrow-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Tungsten-Semibold",
    url: "Tungsten-Semibold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Underwood-Champion",
    url: "Underwood-Champion.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-Regular",
    url: "UntitledSans-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-RegularItalic",
    url: "UntitledSans-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-Bold",
    url: "UntitledSans-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-BoldItalic",
    url: "UntitledSans-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-Black",
    url: "UntitledSans-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-BlackItalic",
    url: "UntitledSans-BlackItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-Light",
    url: "UntitledSans-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-LightItalic",
    url: "UntitledSans-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-Medium",
    url: "UntitledSans-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSans-MediumItalic",
    url: "UntitledSans-MediumItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-Regular",
    url: "UntitledSerif-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-RegularItalic",
    url: "UntitledSerif-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-Bold",
    url: "UntitledSerif-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-BoldItalic",
    url: "UntitledSerif-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-Medium",
    url: "UntitledSerif-Medium.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "UntitledSerif-MediumItalic",
    url: "UntitledSerif-MediumItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Van-Dijck-MT-Regular",
    url: "Van-Dijck-MT-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Van-Dijck-MT-Std-Italic",
    url: "Van-Dijck-MT-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "VendettaMediumItalic-Italic",
    url: "VendettaMediumItalic-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "VendettaMediumPetiteCaps",
    url: "VendettaMediumPetiteCaps.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "VistaSansSCLight",
    url: "VistaSansSCLight.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verdana",
    url: "Verdana.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Black",
    url: "Verlag-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Black-Italic",
    url: "Verlag-Black-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Bold",
    url: "Verlag-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Bold-Italic",
    url: "Verlag-Bold-Italic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Book",
    url: "Verlag-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Book-Italic",
    url: "Verlag-Book-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Extra-Light",
    url: "Verlag-Extra-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Extra-Light-Italic",
    url: "Verlag-Extra-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Light",
    url: "Verlag-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Verlag-Light-Italic",
    url: "Verlag-Light-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Vogue",
    url: "Vogue.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Vogue-Normal",
    url: "Vogue-Normal.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "VTypewriter-RibbonFace",
    url: "VTypewriter-RibbonFace.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Walbaum-MT-Std-Regular",
    url: "Walbaum-MT-Std-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Walbaum-MT-Std-Italic",
    url: "Walbaum-MT-Std-Italic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Walkway-Black",
    url: "Walkway-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Walkway-Bold",
    url: "Walkway-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Walkway-SemiBold",
    url: "Walkway-SemiBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Walkway-UltraBold",
    url: "Walkway-UltraBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-Light",
    url: "Yport-Light.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-LightItalic",
    url: "Yport-LightItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Yport-Book",
    url: "Yport-Book.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-BookItalic",
    url: "Yport-BookItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Yport-Regular",
    url: "Yport-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-RegularItalic",
    url: "Yport-RegularItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Yport-Bold",
    url: "Yport-Bold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-BoldItalic",
    url: "Yport-BoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Yport-SemiBold",
    url: "Yport-SemiBold.woff",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-SemiBoldItalic",
    url: "Yport-SemiBoldItalic.woff",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "Yport-Black",
    url: "Yport-Black.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "Yport-BlackItalic",
    url: "Yport-BlackItalic.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "YportVariableItalic-Regular",
    url: "YportVariableItalic-Regular.woff",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "woff",
  },
  {
    fontFamily: "YportVariableUpright-Regular",
    url: "YportVariableUpright-Regular.woff",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "woff",
  },
  {
    fontFamily: "53Symbols-Regular",
    url: "53Symbols-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ACADEMY-ENGRAVED-LET-REGULAR",
    url: "ACADEMY-ENGRAVED-LET-REGULAR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Abadi MT Condensed Light ttf",
    url: "Abadi MT Condensed Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AbwynPro ttf",
    url: "AbwynPro.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ACaslonPro-Italic ttf",
    url: "ACaslonPro-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ACaslonPro-Regular ttf",
    url: "ACaslonPro-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AdobeBlank ttf",
    url: "AdobeBlank.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AdobeCaslonPro-Bold ttf",
    url: "AdobeCaslonPro-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AdobeCaslonPro-BoldItalic ttf",
    url: "AdobeCaslonPro-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AdobeCaslonPro-Semibold ttf",
    url: "AdobeCaslonPro-Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AdobeCaslonPro-SemiboldItalic ttf",
    url: "AdobeCaslonPro-SemiboldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Aharoni Bold ttf",
    url: "Aharoni Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ahronbd ttf",
    url: "ahronbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AKKURALI TTF",
    url: "AKKURALI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AKKURATL TTF",
    url: "AKKURATL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskBE-LightCn ttf",
    url: "AkzidenzGroteskBE-LightCn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Bold ttf",
    url: "AkzidenzGroteskStd-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-BoldCn ttf",
    url: "AkzidenzGroteskStd-BoldCn.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-BoldCnIt ttf",
    url: "AkzidenzGroteskStd-BoldCnIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-BoldEx ttf",
    url: "AkzidenzGroteskStd-BoldEx.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-BoldExIt ttf",
    url: "AkzidenzGroteskStd-BoldExIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-BoldIt ttf",
    url: "AkzidenzGroteskStd-BoldIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Cn ttf",
    url: "AkzidenzGroteskStd-Cn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-CnIt ttf",
    url: "AkzidenzGroteskStd-CnIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Ext ttf",
    url: "AkzidenzGroteskStd-Ext.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-ExtItalic ttf",
    url: "AkzidenzGroteskStd-ExtItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-It ttf",
    url: "AkzidenzGroteskStd-It.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-LigExtIt ttf",
    url: "AkzidenzGroteskStd-LigExtIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Light ttf",
    url: "AkzidenzGroteskStd-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-LightCn ttf",
    url: "AkzidenzGroteskStd-LightCn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-LightCnItalic ttf",
    url: "AkzidenzGroteskStd-LightCnItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-LightEx ttf",
    url: "AkzidenzGroteskStd-LightEx.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-LightIt ttf",
    url: "AkzidenzGroteskStd-LightIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Md ttf",
    url: "AkzidenzGroteskStd-Md.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-MdCn ttf",
    url: "AkzidenzGroteskStd-MdCn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-MdCnIt ttf",
    url: "AkzidenzGroteskStd-MdCnIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-MdEx ttf",
    url: "AkzidenzGroteskStd-MdEx.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-MdIt ttf",
    url: "AkzidenzGroteskStd-MdIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-MedExtIt ttf",
    url: "AkzidenzGroteskStd-MedExtIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Regular ttf",
    url: "AkzidenzGroteskStd-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-Super ttf",
    url: "AkzidenzGroteskStd-Super.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-SuperItalic ttf",
    url: "AkzidenzGroteskStd-SuperItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-XBd ttf",
    url: "AkzidenzGroteskStd-XBd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-XBdCn ttf",
    url: "AkzidenzGroteskStd-XBdCn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-XBdCnIt ttf",
    url: "AkzidenzGroteskStd-XBdCnIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AkzidenzGroteskStd-XBdIt ttf",
    url: "AkzidenzGroteskStd-XBdIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Algerian ttf",
    url: "Algerian.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AltemusBordersFour-Regular ttf",
    url: "AltemusBordersFour-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AmaticSC-Regular ttf",
    url: "AmaticSC-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "American Text BT ttf",
    url: "American Text BT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Americana Extra Bold BT ttf",
    url: "Americana Extra Bold BT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Americana Extra Bold Condensed BT ttf",
    url: "Americana Extra Bold Condensed BT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AmericanTypewriter",
    url: "AmericanTypewriter.ttc.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "americantypewriter ttf",
    url: "americantypewriter.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AmericanUncD ttf",
    url: "AmericanUncD.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Andalus ttf",
    url: "Andalus.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "andlso ttf",
    url: "andlso.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsa ttf",
    url: "angsa.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsab ttf",
    url: "angsab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsai ttf",
    url: "angsai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Angsana New Bold Italic ttf",
    url: "Angsana New Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Angsana New Bold ttf",
    url: "Angsana New Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Angsana New Italic ttf",
    url: "Angsana New Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Angsana New ttf",
    url: "Angsana New.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AngsanaUPC Bold Italic ttf",
    url: "AngsanaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AngsanaUPC Bold ttf",
    url: "AngsanaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AngsanaUPC Italic ttf",
    url: "AngsanaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "AngsanaUPC ttf",
    url: "AngsanaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsau ttf",
    url: "angsau.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsaub ttf",
    url: "angsaub.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsaui ttf",
    url: "angsaui.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsauz ttf",
    url: "angsauz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "angsaz ttf",
    url: "angsaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AntiqueBookCover ttf",
    url: "AntiqueBookCover.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "aparaj ttf",
    url: "aparaj.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "aparajb ttf",
    url: "aparajb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "aparajbi ttf",
    url: "aparajbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "aparaji ttf",
    url: "aparaji.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Arabic Typesetting ttf",
    url: "Arabic Typesetting.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "arabtype ttf",
    url: "arabtype.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archer Bold Italic ttf",
    url: "Archer Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Archer Bold ttf",
    url: "Archer Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archer Book Italic ttf",
    url: "Archer Book Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Archer Book ttf",
    url: "Archer Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archer Light Italic ttf",
    url: "Archer Light Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Archer Light ttf",
    url: "Archer Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archer Medium Italic ttf",
    url: "Archer Medium Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Archer Medium ttf",
    url: "Archer Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archer Semibold Italic ttf",
    url: "Archer Semibold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Archer Semibold ttf",
    url: "Archer Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Archive_Tilt ttf",
    url: "Archive_Tilt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Arial Black ttf",
    url: "Arial Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Arial Bold Italic ttf",
    url: "Arial Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Arial Bold ttf",
    url: "Arial Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Arial Italic ttf",
    url: "Arial Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "arial ttf",
    url: "arial.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "arialbd ttf",
    url: "arialbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "arialbi ttf",
    url: "arialbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ariali ttf",
    url: "ariali.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ARIALN TTF",
    url: "ARIALN.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ARIALNB TTF",
    url: "ARIALNB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ARIALNBI TTF",
    url: "ARIALNBI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ARIALNI TTF",
    url: "ARIALNI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ariblk ttf",
    url: "ariblk.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ArquitectaBold ttf",
    url: "ArquitectaBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AT825__ TTF",
    url: "AT825__.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AT837___ TTF",
    url: "AT837___.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AT838___ TTF",
    url: "AT838___.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AtlasGrotesk-Light ttf",
    url: "AtlasGrotesk-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AtlasGrotesk-Regular ttf",
    url: "AtlasGrotesk-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Audrey Normal ttf",
    url: "Audrey Normal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Black ttf",
    url: "Avenir-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Black2 ttf",
    url: "Avenir-Black2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-BlackOblique ttf",
    url: "Avenir-BlackOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Book ttf",
    url: "Avenir-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-BookOblique ttf",
    url: "Avenir-BookOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Heavy ttf",
    url: "Avenir-Heavy.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Light ttf",
    url: "Avenir-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Light2 ttf",
    url: "Avenir-Light2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Medium ttf",
    url: "Avenir-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-MediumOblique ttf",
    url: "Avenir-MediumOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Oblique ttf",
    url: "Avenir-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Avenir-Regular2 ttf",
    url: "Avenir-Regular2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Black ttf",
    url: "AvenirLTStd-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-BlackOblique ttf",
    url: "AvenirLTStd-BlackOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Book ttf",
    url: "AvenirLTStd-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-BookOblique ttf",
    url: "AvenirLTStd-BookOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Heavy ttf",
    url: "AvenirLTStd-Heavy.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-HeavyOblique ttf",
    url: "AvenirLTStd-HeavyOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Light ttf",
    url: "AvenirLTStd-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-LightOblique ttf",
    url: "AvenirLTStd-LightOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Medium ttf",
    url: "AvenirLTStd-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-MediumOblique ttf",
    url: "AvenirLTStd-MediumOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Oblique ttf",
    url: "AvenirLTStd-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "AvenirLTStd-Roman ttf",
    url: "AvenirLTStd-Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "B52____ ttf",
    url: "B52____.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BankGothic Lt BT Light ttf",
    url: "BankGothic Lt BT Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BankGothic Md BT Medium ttf",
    url: "BankGothic Md BT Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-Bold ttf",
    url: "Baskerville-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-BoldItalic ttf",
    url: "Baskerville-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-Italic ttf",
    url: "Baskerville-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-Normal-Italic ttf",
    url: "Baskerville-Normal-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-Normal ttf",
    url: "Baskerville-Normal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-SemiBold ttf",
    url: "Baskerville-SemiBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville-SemiBoldItalic ttf",
    url: "Baskerville-SemiBoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Baskerville ttf",
    url: "Baskerville.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BASKVILL TTF",
    url: "BASKVILL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "batang",
    url: "batang.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BatangChe",
    url: "BatangChe.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bauer Bodoni Bold ttf",
    url: "Bauer Bodoni Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bebas Neue Bold ttf",
    url: "Bebas Neue Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bebas Neue Book ttf",
    url: "Bebas Neue Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bebas Neue Light ttf",
    url: "Bebas Neue Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bebas Neue Regular ttf",
    url: "Bebas Neue Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "bebasneue ttf",
    url: "bebasneue.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BELL TTF",
    url: "BELL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BELLB TTF",
    url: "BELLB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BELLI TTF",
    url: "BELLI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BernhardMod BT Bold Italic ttf",
    url: "BernhardMod BT Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BernhardMod BT Bold ttf",
    url: "BernhardMod BT Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BernhardMod BT Italic ttf",
    url: "BernhardMod BT Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BernhardMod BT Roman ttf",
    url: "BernhardMod BT Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-BoldIta2 ttf",
    url: "BertholdWalbaumBook-BoldIta2.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-Italic2 ttf",
    url: "BertholdWalbaumBook-Italic2.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-MedIta2 ttf",
    url: "BertholdWalbaumBook-MedIta2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-MedIta3 ttf",
    url: "BertholdWalbaumBook-MedIta3.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-MedIta4 ttf",
    url: "BertholdWalbaumBook-MedIta4.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BertholdWalbaumBook-Medium2 ttf",
    url: "BertholdWalbaumBook-Medium2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Beton LT Bold Compress ttf",
    url: "Beton LT Bold Compress.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Beton LT Bold Condensed ttf",
    url: "Beton LT Bold Condensed.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Beton LT Bold ttf",
    url: "Beton LT Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Beton LT Demi ttf",
    url: "Beton LT Demi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Beton LT Light ttf",
    url: "Beton LT Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BigCaslon-Medium ttf",
    url: "BigCaslon-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Biscotti-Bold ttf",
    url: "Biscotti-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Blackoak ttf",
    url: "Blackoak.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BlairMdITC TT Medium ttf",
    url: "BlairMdITC TT Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Book Antiqua Bold Italic ttf",
    url: "Book Antiqua Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Book Antiqua Bold ttf",
    url: "Book Antiqua Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Book Antiqua Italic ttf",
    url: "Book Antiqua Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Book Antiqua ttf",
    url: "Book Antiqua.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BOOKOS TTF",
    url: "BOOKOS.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BOOKOSB TTF",
    url: "BOOKOSB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BOOKOSBI TTF",
    url: "BOOKOSBI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BOOKOSI TTF",
    url: "BOOKOSI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Bourgeois-Bold ttf",
    url: "Bourgeois-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BRADHITC TTF",
    url: "BRADHITC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browa ttf",
    url: "browa.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browab ttf",
    url: "browab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browai ttf",
    url: "browai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Browallia New Bold Italic ttf",
    url: "Browallia New Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Browallia New Bold ttf",
    url: "Browallia New Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Browallia New Italic ttf",
    url: "Browallia New Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Browallia New ttf",
    url: "Browallia New.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BrowalliaUPC Bold Italic ttf",
    url: "BrowalliaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BrowalliaUPC Bold ttf",
    url: "BrowalliaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "BrowalliaUPC Italic ttf",
    url: "BrowalliaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BrowalliaUPC ttf",
    url: "BrowalliaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browau ttf",
    url: "browau.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browaub ttf",
    url: "browaub.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browaui ttf",
    url: "browaui.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browauz ttf",
    url: "browauz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "browaz ttf",
    url: "browaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Brown-Bold ttf",
    url: "Brown-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Brown-BoldItalic ttf",
    url: "Brown-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Brown-Italic ttf",
    url: "Brown-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Brown-Light ttf",
    url: "Brown-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Brown-LightItalic ttf",
    url: "Brown-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Brown-Regular ttf",
    url: "Brown-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Brown-RegularItalic ttf",
    url: "Brown-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "BrushScriptMT ttf",
    url: "BrushScriptMT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Calibri Bold Italic ttf",
    url: "Calibri Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Calibri Bold ttf",
    url: "Calibri Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Calibri Italic ttf",
    url: "Calibri Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "calibri ttf",
    url: "calibri.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "calibrib ttf",
    url: "calibrib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "calibrii ttf",
    url: "calibrii.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "calibriz ttf",
    url: "calibriz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CallieHand ttf",
    url: "CallieHand.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cambria Bold Italic ttf",
    url: "Cambria Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Cambria Bold ttf",
    url: "Cambria Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cambria Italic ttf",
    url: "Cambria Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Cambria Math",
    url: "Cambria Math.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cambria ttc",
    url: "cambria.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cambriab ttf",
    url: "cambriab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cambriai ttf",
    url: "cambriai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cambriaz ttf",
    url: "cambriaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Candara Bold Italic ttf",
    url: "Candara Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Candara Bold ttf",
    url: "Candara Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Candara Italic ttf",
    url: "Candara Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Candara ttf",
    url: "Candara.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Candarab ttf",
    url: "Candarab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Candarai ttf",
    url: "Candarai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Candaraz ttf",
    url: "Candaraz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Canela-Regular ttf",
    url: "Canela-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Canela-RegularItalic ttf",
    url: "Canela-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Canela-Thin ttf",
    url: "Canela-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Canela-ThinItalic ttf",
    url: "Canela-ThinItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Capitals ttf",
    url: "Capitals.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Carrosserie-Medium ttf",
    url: "Carrosserie-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Caslon 540 LT Roman ttf",
    url: "Caslon 540 LT Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonFiveForty-Italic ttf",
    url: "CaslonFiveForty-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CaslonFiveForty-ItalicOsF ttf",
    url: "CaslonFiveForty-ItalicOsF.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CaslonFiveForty-Roman ttf",
    url: "CaslonFiveForty-Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonFiveForty-RomanSC ttf",
    url: "CaslonFiveForty-RomanSC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonOldFaceBT ttf",
    url: "CaslonOldFaceBT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonOldFaceHeavyBT ttf",
    url: "CaslonOldFaceHeavyBT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonOldFaceItalicBT ttf",
    url: "CaslonOldFaceItalicBT.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CaslonOpenfaceBT-Regular ttf",
    url: "CaslonOpenfaceBT-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonThree-ItalicOsF ttf",
    url: "CaslonThree-ItalicOsF.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CaslonThree-ItalicOsF1 ttf",
    url: "CaslonThree-ItalicOsF1.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CaslonThree-RomanSC ttf",
    url: "CaslonThree-RomanSC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonThree-RomanSC1 ttf",
    url: "CaslonThree-RomanSC1.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-Black ttf",
    url: "CaslonTwoTwentyFour-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-BlackIt ttf",
    url: "CaslonTwoTwentyFour-BlackIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-Bold ttf",
    url: "CaslonTwoTwentyFour-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-BoldIt ttf",
    url: "CaslonTwoTwentyFour-BoldIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-Book ttf",
    url: "CaslonTwoTwentyFour-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-BookIt ttf",
    url: "CaslonTwoTwentyFour-BookIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-Medium ttf",
    url: "CaslonTwoTwentyFour-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CaslonTwoTwentyFour-MediumIt ttf",
    url: "CaslonTwoTwentyFour-MediumIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CASSIA-R TTF",
    url: "CASSIA-R.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CASSIAEL TTF",
    url: "CASSIAEL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CASSIELI TTF",
    url: "CASSIELI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Catorze27Style1-Black ttf",
    url: "Catorze27Style1-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Catorze27Style1-Medium ttf",
    url: "Catorze27Style1-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cenosbd_ ttf",
    url: "cenosbd_.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CENTAUR TTF",
    url: "CENTAUR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Century Gothic Bold Italic ttf",
    url: "Century Gothic Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Century Gothic Bold ttf",
    url: "Century Gothic Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Century Gothic Italic ttf",
    url: "Century Gothic Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Century Gothic ttf",
    url: "Century Gothic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Century Schoolbook Bold Italic ttf",
    url: "Century Schoolbook Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Century Schoolbook Bold ttf",
    url: "Century Schoolbook Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Century Schoolbook Italic ttf",
    url: "Century Schoolbook Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Century Schoolbook ttf",
    url: "Century Schoolbook.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CENTURY TTF",
    url: "CENTURY.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CENTURY2 TTF",
    url: "CENTURY2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CENTURY3 TTF",
    url: "CENTURY3.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CenturyGothic ttf",
    url: "CenturyGothic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Champagne & Limousines Bold Italic ttf",
    url: "Champagne & Limousines Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Champagne & Limousines Bold ttf",
    url: "Champagne & Limousines Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Champagne & Limousines Italic ttf",
    url: "Champagne & Limousines Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Champagne & Limousines ttf",
    url: "Champagne & Limousines.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Champagne&Limousines-Bold ttf",
    url: "Champagne&Limousines-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Champagne&Limousines-BoldItalic ttf",
    url: "Champagne&Limousines-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Champagne&Limousines-Italic ttf",
    url: "Champagne&Limousines-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Champagne&Limousines ttf",
    url: "Champagne&Limousines.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Chaparral Pro ttf",
    url: "Chaparral Pro.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Chipperb ttf",
    url: "Chipperb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cinzel-Black ttf",
    url: "Cinzel-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cinzel-Bold ttf",
    url: "Cinzel-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cinzel-Regular ttf",
    url: "Cinzel-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CinzelDecorative-Black ttf",
    url: "CinzelDecorative-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CinzelDecorative-Bold ttf",
    url: "CinzelDecorative-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CinzelDecorative-Regular ttf",
    url: "CinzelDecorative-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ClarendonLTStd ttf",
    url: "ClarendonLTStd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "COCHIN__ TTF",
    url: "COCHIN__.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "COCHIN-B TTF",
    url: "COCHIN-B.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cochin-Bold otf",
    url: "Cochin-Bold.otf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Cochin-BoldItalic otf",
    url: "Cochin-BoldItalic.otf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "opentype",
  },
  {
    fontFamily: "COCHIN-I TTF",
    url: "COCHIN-I.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cochin-Italic otf",
    url: "Cochin-Italic.otf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "opentype",
  },
  {
    fontFamily: "Cochin otf",
    url: "Cochin.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "COCHINBI TTF",
    url: "COCHINBI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocktailShaker ttf",
    url: "CocktailShaker.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Bold ttf",
    url: "CocoSharp-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-BoldItalic ttf",
    url: "CocoSharp-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Extrabold ttf",
    url: "CocoSharp-Extrabold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-ExtraboldItalic ttf",
    url: "CocoSharp-ExtraboldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-ExtraLight ttf",
    url: "CocoSharp-ExtraLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-ExtraLightItalic ttf",
    url: "CocoSharp-ExtraLightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Heavy ttf",
    url: "CocoSharp-Heavy.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-HeavyItalic ttf",
    url: "CocoSharp-HeavyItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Italic ttf",
    url: "CocoSharp-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Light ttf",
    url: "CocoSharp-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-LightItalic ttf",
    url: "CocoSharp-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CocoSharp-Regular ttf",
    url: "CocoSharp-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Comic Sans MS Bold ttf",
    url: "Comic Sans MS Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Comic Sans MS ttf",
    url: "Comic Sans MS.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "comic ttf",
    url: "comic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "comicbd ttf",
    url: "comicbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "consola ttf",
    url: "consola.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "consolab ttf",
    url: "consolab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "consolai ttf",
    url: "consolai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Consolas Bold Italic ttf",
    url: "Consolas Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Consolas Bold ttf",
    url: "Consolas Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Consolas Italic ttf",
    url: "Consolas Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Consolas ttf",
    url: "Consolas.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "consolaz ttf",
    url: "consolaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "constan ttf",
    url: "constan.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "constanb ttf",
    url: "constanb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "constani ttf",
    url: "constani.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Constantia Bold Italic ttf",
    url: "Constantia Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Constantia Bold ttf",
    url: "Constantia Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Constantia Italic ttf",
    url: "Constantia Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Constantia ttf",
    url: "Constantia.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "constanz ttf",
    url: "constanz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Copperplate (1) ttf",
    url: "Copperplate (1).ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Copperplate Gothic Bold BT",
    url: "Copperplate Gothic Bold BT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Copperplate Gothic LT Thirty-One BC",
    url: "Copperplate Gothic LT Thirty-One BC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Copperplate Gothic LT Thirty-Two BC",
    url: "Copperplate Gothic LT Thirty-Two BC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Copperplate Gothic LT Twenty-Nine BC",
    url: "Copperplate Gothic LT Twenty-Nine BC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CopperplateGothic-Bold ttf",
    url: "CopperplateGothic-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corbel Bold Italic ttf",
    url: "Corbel Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Corbel Bold ttf",
    url: "Corbel Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corbel Italic ttf",
    url: "Corbel Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "corbel ttf",
    url: "corbel.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "corbelb ttf",
    url: "corbelb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "corbeli ttf",
    url: "corbeli.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "corbelz ttf",
    url: "corbelz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cordia New Bold Italic ttf",
    url: "Cordia New Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Cordia New Bold ttf",
    url: "Cordia New Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Cordia New Italic ttf",
    url: "Cordia New Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Cordia New ttf",
    url: "Cordia New.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordia ttf",
    url: "cordia.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiab ttf",
    url: "cordiab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiai ttf",
    url: "cordiai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiau ttf",
    url: "cordiau.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiaub ttf",
    url: "cordiaub.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiaui ttf",
    url: "cordiaui.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CordiaUPC Bold Italic ttf",
    url: "CordiaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CordiaUPC Bold ttf",
    url: "CordiaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CordiaUPC Italic ttf",
    url: "CordiaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CordiaUPC ttf",
    url: "CordiaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiauz ttf",
    url: "cordiauz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cordiaz ttf",
    url: "cordiaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corki_Rounded_Tuscan otf ttf",
    url: "Corki_Rounded_Tuscan.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corki_Rounded otf ttf",
    url: "Corki_Rounded.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corki_Tuscan otf ttf",
    url: "Corki_Tuscan.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corki otf ttf",
    url: "Corki.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Corsiva MT Std ttf",
    url: "Corsiva MT Std.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "cour ttf",
    url: "cour.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "courbd ttf",
    url: "courbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "courbi ttf",
    url: "courbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "couri ttf",
    url: "couri.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Courier New Bold Italic ttf",
    url: "Courier New Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Courier New Bold ttf",
    url: "Courier New Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Courier New Italic ttf",
    url: "Courier New Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Courier New ttf",
    url: "Courier New.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Craw Modern Regular ttf",
    url: "Craw Modern Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CrawModURW-RegIta ttf",
    url: "CrawModURW-RegIta.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CrawModURWTBol ttf",
    url: "CrawModURWTBol.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Bold ttf",
    url: "CronosPro-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldCapt ttf",
    url: "CronosPro-BoldCapt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldCaptIt ttf",
    url: "CronosPro-BoldCaptIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldDisp ttf",
    url: "CronosPro-BoldDisp.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldDispIt ttf",
    url: "CronosPro-BoldDispIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldIt ttf",
    url: "CronosPro-BoldIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldSubh ttf",
    url: "CronosPro-BoldSubh.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-BoldSubhIt ttf",
    url: "CronosPro-BoldSubhIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Capt ttf",
    url: "CronosPro-Capt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-CaptIt ttf",
    url: "CronosPro-CaptIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Disp ttf",
    url: "CronosPro-Disp.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-DispIt ttf",
    url: "CronosPro-DispIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Italic ttf",
    url: "CronosPro-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Lt ttf",
    url: "CronosPro-Lt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtCapt ttf",
    url: "CronosPro-LtCapt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtCaptIt ttf",
    url: "CronosPro-LtCaptIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtDisp ttf",
    url: "CronosPro-LtDisp.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtDispIt ttf",
    url: "CronosPro-LtDispIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtIt ttf",
    url: "CronosPro-LtIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtSubh ttf",
    url: "CronosPro-LtSubh.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-LtSubhIt ttf",
    url: "CronosPro-LtSubhIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Regular ttf",
    url: "CronosPro-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Semibold ttf",
    url: "CronosPro-Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldCapt ttf",
    url: "CronosPro-SemiboldCapt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldCaptIt ttf",
    url: "CronosPro-SemiboldCaptIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldDisp ttf",
    url: "CronosPro-SemiboldDisp.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldDispIt ttf",
    url: "CronosPro-SemiboldDispIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldIt ttf",
    url: "CronosPro-SemiboldIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldSubh ttf",
    url: "CronosPro-SemiboldSubh.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SemiboldSubhIt ttf",
    url: "CronosPro-SemiboldSubhIt.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-Subh ttf",
    url: "CronosPro-Subh.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "CronosPro-SubhIt ttf",
    url: "CronosPro-SubhIt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DanielsDBGB-Regular ttf",
    url: "DanielsDBGB-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "daunpenh ttf",
    url: "daunpenh.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "David Bold ttf",
    url: "David Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "david ttf",
    url: "david.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "davidbd ttf",
    url: "davidbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Dense-Regular ttf",
    url: "Dense-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Designer-Notes-Bold ttf",
    url: "Designer-Notes-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Designer-Notes ttf",
    url: "Designer-Notes.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "desktop ini",
    url: "desktop.ini",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DFKai-SB ttf",
    url: "DFKai-SB.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Didot-Bold ttf",
    url: "Didot-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Didot-Italic ttf",
    url: "Didot-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Didot ttf",
    url: "Didot.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DilleniaUPC Bold Italic ttf",
    url: "DilleniaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "DilleniaUPC Bold ttf",
    url: "DilleniaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DilleniaUPC Italic ttf",
    url: "DilleniaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "DilleniaUPC ttf",
    url: "DilleniaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Alternate Black ttf",
    url: "DIN Alternate Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Alternate Bold ttf",
    url: "DIN Alternate Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Alternate Light ttf",
    url: "DIN Alternate Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Alternate Medium ttf",
    url: "DIN Alternate Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Alternate ttf",
    url: "DIN Alternate.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Black ttf",
    url: "DIN Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN BlackAlternate ttf",
    url: "DIN BlackAlternate.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Bold ttf",
    url: "DIN Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN BoldAlternate ttf",
    url: "DIN BoldAlternate.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Light ttf",
    url: "DIN Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN LightAlternate ttf",
    url: "DIN LightAlternate.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Medium ttf",
    url: "DIN Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN MediumAlternate ttf",
    url: "DIN MediumAlternate.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN RegularAlternate ttf",
    url: "DIN RegularAlternate.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN Schablonierschrift ttf",
    url: "DIN Schablonierschrift.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN-Black ttf",
    url: "DIN-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DIN ttf",
    url: "DIN.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "dokchamp ttf",
    url: "dokchamp.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DokChampa ttf",
    url: "DokChampa.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "DTLDocumentaSansTOT-Regular ttf",
    url: "DTLDocumentaSansTOT-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Eagle-Light ttf",
    url: "Eagle-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ebrima ttf",
    url: "ebrima.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ebrimabd ttf",
    url: "ebrimabd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EdwardianScriptITC ttf",
    url: "EdwardianScriptITC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Elderkin-Bold ttf",
    url: "Elderkin-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-Black ttf",
    url: "EnglishGrotesque-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-Bold ttf",
    url: "EnglishGrotesque-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-ExtraBold ttf",
    url: "EnglishGrotesque-ExtraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-Light ttf",
    url: "EnglishGrotesque-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-Medium ttf",
    url: "EnglishGrotesque-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EnglishGrotesque-Thin ttf",
    url: "EnglishGrotesque-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ENGR TTF",
    url: "ENGR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EngraversGothic BT ttf",
    url: "EngraversGothic BT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EngraversGothicBoldTTT ttf",
    url: "EngraversGothicBoldTTT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EngraversLH-BoldFace ttf",
    url: "EngraversLH-BoldFace.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EngraversLT-Bold ttf",
    url: "EngraversLT-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Entypo ttf",
    url: "Entypo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Estrangelo Edessa ttf",
    url: "Estrangelo Edessa.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "estre ttf",
    url: "estre.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-Bold ttf",
    url: "EuclidCircularB-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-BoldItalic ttf",
    url: "EuclidCircularB-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-Light ttf",
    url: "EuclidCircularB-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-LightItalic ttf",
    url: "EuclidCircularB-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-Medium ttf",
    url: "EuclidCircularB-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-MediumItalic ttf",
    url: "EuclidCircularB-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-Regular ttf",
    url: "EuclidCircularB-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-RegularItalic ttf",
    url: "EuclidCircularB-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-SemBdIta ttf",
    url: "EuclidCircularB-SemBdIta.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EuclidCircularB-Semibold ttf",
    url: "EuclidCircularB-Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EucrosiaUPC Bold Italic ttf",
    url: "EucrosiaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EucrosiaUPC Bold ttf",
    url: "EucrosiaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "EucrosiaUPC Italic ttf",
    url: "EucrosiaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "EucrosiaUPC ttf",
    url: "EucrosiaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "euphemia ttf",
    url: "euphemia.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Existence-Light ttf",
    url: "Existence-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Existence-Light2 ttf",
    url: "Existence-Light2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Existence-StencilLight ttf",
    url: "Existence-StencilLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Existence-UnicaseLight ttf",
    url: "Existence-UnicaseLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FangSong ttf",
    url: "FangSong.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FavoritStd-MediumExtended ttf",
    url: "FavoritStd-MediumExtended.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Fedra Serif A Book Small Caps ttf",
    url: "Fedra Serif A Book Small Caps.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FiliScript ttf",
    url: "FiliScript.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FilosofiaBold ttf",
    url: "FilosofiaBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FilosofiaItalic ttf",
    url: "FilosofiaItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FilosofiaRegular ttf",
    url: "FilosofiaRegular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FilosofiaRegularLining ttf",
    url: "FilosofiaRegularLining.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Folio LT Bold ttf",
    url: "Folio LT Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Folio LT Light ttf",
    url: "Folio LT Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "framd ttf",
    url: "framd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "framdit ttf",
    url: "framdit.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "frank ttf",
    url: "frank.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Franklin Gothic Medium Italic ttf",
    url: "Franklin Gothic Medium Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Franklin Gothic Medium ttf",
    url: "Franklin Gothic Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FrankRuehl ttf",
    url: "FrankRuehl.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreesiaUPC Bold Italic ttf",
    url: "FreesiaUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreesiaUPC Bold ttf",
    url: "FreesiaUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreesiaUPC Italic ttf",
    url: "FreesiaUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreesiaUPC ttf",
    url: "FreesiaUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBlack-Italic ttf",
    url: "FreightDispProBlack-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBlack-Regular ttf",
    url: "FreightDispProBlack-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBold-Italic ttf",
    url: "FreightDispProBold-Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBold-Regular ttf",
    url: "FreightDispProBold-Regular.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBook-Italic ttf",
    url: "FreightDispProBook-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProBook-Regular ttf",
    url: "FreightDispProBook-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProLight-Italic ttf",
    url: "FreightDispProLight-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProLight-Regular ttf",
    url: "FreightDispProLight-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProMedium-Italic ttf",
    url: "FreightDispProMedium-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProMedium-Regular ttf",
    url: "FreightDispProMedium-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProSemibold-Italic ttf",
    url: "FreightDispProSemibold-Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FreightDispProSemibold-Regular ttf",
    url: "FreightDispProSemibold-Regular.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Frutiger LT 45 Light ttf",
    url: "Frutiger LT 45 Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Frutiger LT 55 Roman ttf",
    url: "Frutiger LT 55 Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "fubk__ ttf",
    url: "fubk__.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "fubko_ ttf",
    url: "fubko_.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Black-Oblique ttf",
    url: "Futura-Black-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Black ttf",
    url: "Futura-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Bold-Oblique ttf",
    url: "Futura-Bold-Oblique.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Bold ttf",
    url: "Futura-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-ExtraBold-Oblique ttf",
    url: "Futura-ExtraBold-Oblique.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-ExtraBold ttf",
    url: "Futura-ExtraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Light-Oblique ttf",
    url: "Futura-Light-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Light ttf",
    url: "Futura-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Lt-BT ttf",
    url: "Futura-Lt-BT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Medium-Oblique ttf",
    url: "Futura-Medium-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Medium ttf",
    url: "Futura-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Oblique ttf",
    url: "Futura-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Futura-Regular ttf",
    url: "Futura-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaBkBTBook-Italic ttf",
    url: "FuturaBkBTBook-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FuturaBT-Light ttf",
    url: "FuturaBT-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaLtBT-Bold ttf",
    url: "FuturaLtBT-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaLtBT-BoldItalic ttf",
    url: "FuturaLtBT-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FuturaLtBT-Light ttf",
    url: "FuturaLtBT-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaLtBT-LightItalic ttf",
    url: "FuturaLtBT-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "FuturaNo2D-DemiBold ttf",
    url: "FuturaNo2D-DemiBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaNo2D-Medium ttf",
    url: "FuturaNo2D-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaNo2SCD-Boo ttf",
    url: "FuturaNo2SCD-Boo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FUTURASM TTF",
    url: "FUTURASM.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaT-Book ttf",
    url: "FuturaT-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "FuturaTEE-Medi ttf",
    url: "FuturaTEE-Medi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gabriola ttf",
    url: "Gabriola.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-Black ttf",
    url: "Galliard-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-BlackItalic ttf",
    url: "Galliard-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-Bold ttf",
    url: "Galliard-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-BoldItalic ttf",
    url: "Galliard-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-Italic ttf",
    url: "Galliard-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-Roman ttf",
    url: "Galliard-Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-Ultra ttf",
    url: "Galliard-Ultra.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Galliard-UltraItalic ttf",
    url: "Galliard-UltraItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCItAltCC ttf",
    url: "GalliardITCItAltCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCItCC ttf",
    url: "GalliardITCItCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCItExpCC ttf",
    url: "GalliardITCItExpCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCItFracCC ttf",
    url: "GalliardITCItFracCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCItOStyCC ttf",
    url: "GalliardITCItOStyCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmAltCC ttf",
    url: "GalliardITCRmAltCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmCC ttf",
    url: "GalliardITCRmCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmExpCC ttf",
    url: "GalliardITCRmExpCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmFracCC ttf",
    url: "GalliardITCRmFracCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmOStyCC ttf",
    url: "GalliardITCRmOStyCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GalliardITCRmSCapCC ttf",
    url: "GalliardITCRmSCapCC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GARA TTF",
    url: "GARA.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GARABD TTF",
    url: "GARABD.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GARAIT TTF",
    url: "GARAIT.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Garamond Bold ttf",
    url: "Garamond Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Garamond Italic ttf",
    url: "Garamond Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Garamond ttf",
    url: "Garamond.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Garamond3LTStd ttf",
    url: "Garamond3LTStd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "gautami ttf",
    url: "gautami.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "gautamib ttf",
    url: "gautamib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Geneva TTF",
    url: "Geneva.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Georgia Bold Italic ttf",
    url: "Georgia Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Georgia Bold ttf",
    url: "Georgia Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Georgia Italic ttf",
    url: "Georgia Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "georgia ttf",
    url: "georgia.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "georgiab ttf",
    url: "georgiab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "georgiai ttf",
    url: "georgiai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "georgiaz ttf",
    url: "georgiaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GIL____ TTF",
    url: "GIL____.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GILB___ TTF",
    url: "GILB___.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gill Sans - Light TTF",
    url: "Gill Sans - Light.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GillSansMTPro-Light ttf",
    url: "GillSansMTPro-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GillSansMTPro-LightItalic ttf",
    url: "GillSansMTPro-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "GillSansStd_Bold ttf",
    url: "GillSansStd_Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GillSansStd_LightItalic ttf",
    url: "GillSansStd_LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "GillSansStd ttf",
    url: "GillSansStd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gisha Bold ttf",
    url: "Gisha Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "gisha ttf",
    url: "gisha.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "gishabd ttf",
    url: "gishabd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GlobalMonospace CompositeFont",
    url: "GlobalMonospace.CompositeFont",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GlobalSansSerif CompositeFont",
    url: "GlobalSansSerif.CompositeFont",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GlobalSerif CompositeFont",
    url: "GlobalSerif.CompositeFont",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GlobalUserInterface CompositeFont",
    url: "GlobalUserInterface.CompositeFont",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GoodHeadlineOffc-CondMedium ttf",
    url: "GoodHeadlineOffc-CondMedium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GoodHeadlineScOffc-CondMedium ttf",
    url: "GoodHeadlineScOffc-CondMedium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Black ttf",
    url: "Gotham-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-BlackItalic ttf",
    url: "Gotham-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Bold ttf",
    url: "Gotham-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-BoldItalic ttf",
    url: "Gotham-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Book ttf",
    url: "Gotham-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-BookItalic ttf",
    url: "Gotham-BookItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-ExtraLight ttf",
    url: "Gotham-ExtraLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-ExtraLightItalic ttf",
    url: "Gotham-ExtraLightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Light ttf",
    url: "Gotham-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-LightItalic ttf",
    url: "Gotham-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Medium ttf",
    url: "Gotham-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-MediumItalic ttf",
    url: "Gotham-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Thin ttf",
    url: "Gotham-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-ThinItalic ttf",
    url: "Gotham-ThinItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-Ultra ttf",
    url: "Gotham-Ultra.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gotham-UltraItalic ttf",
    url: "Gotham-UltraItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Goudy Old Style Bold ttf",
    url: "Goudy Old Style Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Goudy Old Style Italic ttf",
    url: "Goudy Old Style Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Goudy Old Style ttf",
    url: "Goudy Old Style.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Goudy Stout ttf",
    url: "Goudy Stout.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Gramercy Gothic ttf",
    url: "Gramercy Gothic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GrandSlang-B-Side ttf",
    url: "GrandSlang-B-Side.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GrandSlang-Italic ttf",
    url: "GrandSlang-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "GrandSlang-Roman ttf",
    url: "GrandSlang-Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "GTAlpina-Rg ttf",
    url: "GTAlpina-Rg.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "gulim ttc",
    url: "gulim.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HaasGrotText-55Roman ttf",
    url: "HaasGrotText-55Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HaasGrotText-75Bold ttf",
    url: "HaasGrotText-75Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Handle Oldstyle ttf",
    url: "Handle Oldstyle.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HarrietText-Light ttf",
    url: "HarrietText-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HarrietText-LightItalic ttf",
    url: "HarrietText-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HEADOH__ TTF",
    url: "HEADOH__.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HEADTH__ TTF",
    url: "HEADTH__.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Heebo-Light ttf",
    url: "Heebo-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Heebo-Regular ttf",
    url: "Heebo-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Heebo-Thin ttf",
    url: "Heebo-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-Bold ttf",
    url: "HeldaneText-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-BoldItalic ttf",
    url: "HeldaneText-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-Medium ttf",
    url: "HeldaneText-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-MediumItalic ttf",
    url: "HeldaneText-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-Regular ttf",
    url: "HeldaneText-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HeldaneText-RegularItalic ttf",
    url: "HeldaneText-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTS1 TTF",
    url: "HELNLTS1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSB TTF",
    url: "HELNLTSB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSC TTF",
    url: "HELNLTSC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSE TTF",
    url: "HELNLTSE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSH TTF",
    url: "HELNLTSH.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSI TTF",
    url: "HELNLTSI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSL TTF",
    url: "HELNLTSL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSM TTF",
    url: "HELNLTSM.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTSR TTF",
    url: "HELNLTSR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HELNLTST TTF",
    url: "HELNLTST.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica-Bold ttf",
    url: "Helvetica-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica-BoldOblique ttf",
    url: "Helvetica-BoldOblique.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica-Light ttf",
    url: "Helvetica-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica-LightOblique ttf",
    url: "Helvetica-LightOblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica-Oblique ttf",
    url: "Helvetica-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Helvetica ttf",
    url: "Helvetica.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HelveticaNeueLTStd45Light-Reg ttf",
    url: "HelveticaNeueLTStd45Light-Reg.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HelveticaNeueLTStd46LightItal ttf",
    url: "HelveticaNeueLTStd46LightItal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB1 TTF",
    url: "HENLTSB1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB2 TTF",
    url: "HENLTSB2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB3 TTF",
    url: "HENLTSB3.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB4 TTF",
    url: "HENLTSB4.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB5 TTF",
    url: "HENLTSB5.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSB6 TTF",
    url: "HENLTSB6.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSBC TTF",
    url: "HENLTSBC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSBE TTF",
    url: "HENLTSBE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSBI TTF",
    url: "HENLTSBI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSBO TTF",
    url: "HENLTSBO.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSCO TTF",
    url: "HENLTSCO.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSEO TTF",
    url: "HENLTSEO.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSH1 TTF",
    url: "HENLTSH1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSH2 TTF",
    url: "HENLTSH2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSHC TTF",
    url: "HENLTSHC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSHE TTF",
    url: "HENLTSHE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSHI TTF",
    url: "HENLTSHI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSL1 TTF",
    url: "HENLTSL1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSL2 TTF",
    url: "HENLTSL2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSLC TTF",
    url: "HENLTSLC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSLE TTF",
    url: "HENLTSLE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSLI TTF",
    url: "HENLTSLI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSM1 TTF",
    url: "HENLTSM1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSM2 TTF",
    url: "HENLTSM2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSMC TTF",
    url: "HENLTSMC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSME TTF",
    url: "HENLTSME.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSMI TTF",
    url: "HENLTSMI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTST1 TTF",
    url: "HENLTST1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTST2 TTF",
    url: "HENLTST2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSTC TTF",
    url: "HENLTSTC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSTE TTF",
    url: "HENLTSTE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSTI TTF",
    url: "HENLTSTI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSU1 TTF",
    url: "HENLTSU1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSU2 TTF",
    url: "HENLTSU2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSU3 TTF",
    url: "HENLTSU3.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSU4 TTF",
    url: "HENLTSU4.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSU5 TTF",
    url: "HENLTSU5.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSUL TTF",
    url: "HENLTSUL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSX1 TTF",
    url: "HENLTSX1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HENLTSXB TTF",
    url: "HENLTSXB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HiLo-Deco ttf",
    url: "HiLo-Deco.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "himalaya ttf",
    url: "himalaya.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HoeflerText-Black ttf",
    url: "HoeflerText-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "HoeflerText-BlackItalic ttf",
    url: "HoeflerText-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HoeflerText-Italic ttf",
    url: "HoeflerText-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "HoeflerText-Regular ttf",
    url: "HoeflerText-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "I-Still-Believe ttf",
    url: "I-Still-Believe.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IDAutomationHC39M ttf",
    url: "IDAutomationHC39M.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_Double_Pica_PRO_Italic ttf",
    url: "IM_FELL_Double_Pica_PRO_Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_Double_Pica_PRO_Roman ttf",
    url: "IM_FELL_Double_Pica_PRO_Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_DW_Pica_PRO_Italic ttf",
    url: "IM_FELL_DW_Pica_PRO_Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_DW_Pica_PRO_Roman ttf",
    url: "IM_FELL_DW_Pica_PRO_Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_English_PRO_Italic ttf",
    url: "IM_FELL_English_PRO_Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_English_PRO_Roman ttf",
    url: "IM_FELL_English_PRO_Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_FLOWERS_1 ttf",
    url: "IM_FELL_FLOWERS_1.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_FLOWERS_2 ttf",
    url: "IM_FELL_FLOWERS_2.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_French_Canon_PRO_Italic ttf",
    url: "IM_FELL_French_Canon_PRO_Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_French_Canon_PRO_Roman ttf",
    url: "IM_FELL_French_Canon_PRO_Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_Great_Primer_PRO_Italic ttf",
    url: "IM_FELL_Great_Primer_PRO_Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_Great_Primer_PRO_Roman ttf",
    url: "IM_FELL_Great_Primer_PRO_Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IM_FELL_THREE_LINE_PICA_PRO ttf",
    url: "IM_FELL_THREE_LINE_PICA_PRO.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "impact ttf",
    url: "impact.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IrisUPC Bold Italic ttf",
    url: "IrisUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IrisUPC Bold ttf",
    url: "IrisUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "IrisUPC Italic ttf",
    url: "IrisUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "IrisUPC ttf",
    url: "IrisUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Iskoola Pota ttf",
    url: "Iskoola Pota.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "iskpota ttf",
    url: "iskpota.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "iskpotab ttf",
    url: "iskpotab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITC Officina Serif Bold Italic ttf",
    url: "ITC Officina Serif Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITC Officina Serif Bold ttf",
    url: "ITC Officina Serif Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITC Officina Serif Book Italic ttf",
    url: "ITC Officina Serif Book Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITC Officina Serif Book ttf",
    url: "ITC Officina Serif Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCCenturyStd-BookItalic ttf",
    url: "ITCCenturyStd-BookItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITCGalliard-BlackItalic2 ttf",
    url: "ITCGalliard-BlackItalic2.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITCGalliard-Bold2 ttf",
    url: "ITCGalliard-Bold2.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCGalliard-BoldItalic3 ttf",
    url: "ITCGalliard-BoldItalic3.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITCGalliard-BoldItalic4 ttf",
    url: "ITCGalliard-BoldItalic4.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITCKabelStd-Bold ttf",
    url: "ITCKabelStd-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCKabelStd-Book ttf",
    url: "ITCKabelStd-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCKabelStd-Demi ttf",
    url: "ITCKabelStd-Demi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCKabelStd-Medium ttf",
    url: "ITCKabelStd-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCKabelStd-Ultra ttf",
    url: "ITCKabelStd-Ultra.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Bold ttf",
    url: "ITCVeljovicStdBook-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Italic ttf",
    url: "ITCVeljovicStdBook-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ITCVeljovicStdBook-Regular ttf",
    url: "ITCVeljovicStdBook-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "JansonText-Bold otf ttf",
    url: "JansonText-Bold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "JansonText-BoldItalic otf ttf",
    url: "JansonText-BoldItalic.otf.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "JansonText-Italic otf ttf",
    url: "JansonText-Italic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "JansonText-Roman otf ttf",
    url: "JansonText-Roman.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "JasmineUPC Bold Italic ttf",
    url: "JasmineUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "JasmineUPC Bold ttf",
    url: "JasmineUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "JasmineUPC Italic ttf",
    url: "JasmineUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "JasmineUPC ttf",
    url: "JasmineUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "KaiTi ttf",
    url: "KaiTi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kaiu ttf",
    url: "kaiu.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kalinga ttf",
    url: "kalinga.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kalingab ttf",
    url: "kalingab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "karabinE .ttf",
    url: "karabinE..ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kartika ttf",
    url: "kartika.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kartikab ttf",
    url: "kartikab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "KhmerUI ttf",
    url: "KhmerUI.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "KhmerUIb ttf",
    url: "KhmerUIb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Knockout-HTF26-JuniorFlyweight ttf",
    url: "Knockout-HTF26-JuniorFlyweight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Knockout-HTF27-JuniorBantamwt ttf",
    url: "Knockout-HTF27-JuniorBantamwt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Knockout-HTF28-JuniorFeatherwt ttf",
    url: "Knockout-HTF28-JuniorFeatherwt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Knockout-HTF29-JuniorLiteweight ttf",
    url: "Knockout-HTF29-JuniorLiteweight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Knockout-HTF30-JuniorWelterwt ttf",
    url: "Knockout-HTF30-JuniorWelterwt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "KodchiangUPC Bold Italic ttf",
    url: "KodchiangUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "KodchiangUPC Bold ttf",
    url: "KodchiangUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "KodchiangUPC Italic ttf",
    url: "KodchiangUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "KodchiangUPC ttf",
    url: "KodchiangUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kokila ttf",
    url: "kokila.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kokilab ttf",
    url: "kokilab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kokilabi ttf",
    url: "kokilabi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "kokilai ttf",
    url: "kokilai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "l_10646 ttf",
    url: "l_10646.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LaoUI ttf",
    url: "LaoUI.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LaoUIb ttf",
    url: "LaoUIb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "latha ttf",
    url: "latha.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "lathab ttf",
    url: "lathab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Latin-Elongated ttf",
    url: "Latin-Elongated.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LatinWide ttf",
    url: "LatinWide.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato Black Italic ttf",
    url: "Lato Black Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Lato Black ttf",
    url: "Lato Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato Bold TTF",
    url: "Lato Bold.TTF",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato BoldItalic TTF",
    url: "Lato BoldItalic.TTF",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Lato Italic TTF",
    url: "Lato Italic.TTF",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Lato Light TTF",
    url: "Lato Light.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato Regular TTF",
    url: "Lato Regular.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato-Black ttf",
    url: "Lato-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato-BlackItalic ttf",
    url: "Lato-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Lato-Bold ttf",
    url: "Lato-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato-Hairline ttf",
    url: "Lato-Hairline.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lato-HairlineItalic ttf",
    url: "Lato-HairlineItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Lato-LightItalic ttf",
    url: "Lato-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "LBRITE TTF",
    url: "LBRITE.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LBRITED TTF",
    url: "LBRITED.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LBRITEDI TTF",
    url: "LBRITEDI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LBRITEI TTF",
    url: "LBRITEI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LeagueGothic-Regular ttf",
    url: "LeagueGothic-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "leelawad ttf",
    url: "leelawad.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Leelawadee Bold ttf",
    url: "Leelawadee Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Leelawadee ttf",
    url: "Leelawadee.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "leelawdb ttf",
    url: "leelawdb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Levenim MT Bold ttf",
    url: "Levenim MT Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Levenim MT ttf",
    url: "Levenim MT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LilyUPC Bold Italic ttf",
    url: "LilyUPC Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "LilyUPC Bold ttf",
    url: "LilyUPC Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LilyUPC Italic ttf",
    url: "LilyUPC Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "LilyUPC ttf",
    url: "LilyUPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LinotypeUnivers-CondThin ttf",
    url: "LinotypeUnivers-CondThin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LondonMM ttf",
    url: "LondonMM.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lucida Console ttf",
    url: "Lucida Console.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Lucida Sans Unicode ttf",
    url: "Lucida Sans Unicode.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "LucidaCalligraphyItalic TTF",
    url: "LucidaCalligraphyItalic.TTF",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "lucon ttf",
    url: "lucon.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "lvnm ttf",
    url: "lvnm.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "lvnmbd ttf",
    url: "lvnmbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MAIAN TTF",
    url: "MAIAN.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "majalla ttf",
    url: "majalla.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "majallab ttf",
    url: "majallab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Malgun Gothic Bold ttf",
    url: "Malgun Gothic Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Malgun Gothic ttf",
    url: "Malgun Gothic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "malgun ttf",
    url: "malgun.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "malgunbd ttf",
    url: "malgunbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mangal ttf",
    url: "mangal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mangalb ttf",
    url: "mangalb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Marian1812-Italic ttf",
    url: "Marian1812-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "marlett ttf",
    url: "marlett.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MCMHW TTF",
    url: "MCMHW.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Meiryo UI Bold Italic ttc",
    url: "Meiryo UI Bold Italic.ttc",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "meiryo ttc",
    url: "meiryo.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "meiryob ttc",
    url: "meiryob.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Melior-Italic ttf",
    url: "Melior-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Melior ttf",
    url: "Melior.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MerryChristmasFlake ttf",
    url: "MerryChristmasFlake.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft Himalaya ttf",
    url: "Microsoft Himalaya.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft JhengHei Bold ttf",
    url: "Microsoft JhengHei Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft JhengHei ttf",
    url: "Microsoft JhengHei.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft Sans Serif ttf",
    url: "Microsoft Sans Serif.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft Uighur ttf",
    url: "Microsoft Uighur.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft YaHei Bold ttf",
    url: "Microsoft YaHei Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft YaHei ttf",
    url: "Microsoft YaHei.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Microsoft Yi Baiti ttf",
    url: "Microsoft Yi Baiti.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "micross ttf",
    url: "micross.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MingLiU_HKSCS ttc",
    url: "MingLiU_HKSCS.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MingLiU-ExtB ttc",
    url: "MingLiU-ExtB.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mingliu ttc",
    url: "mingliu.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mingliub ttc",
    url: "mingliub.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Minion Pro ttf",
    url: "Minion Pro.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPB TTF",
    url: "MINIONPB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPR TTF",
    url: "MINIONPR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-BOLD ttf",
    url: "MINIONPRO-BOLD.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-BOLDCN ttf",
    url: "MINIONPRO-BOLDCN.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-BOLDCNIT ttf",
    url: "MINIONPRO-BOLDCNIT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-BOLDIT ttf",
    url: "MINIONPRO-BOLDIT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-IT ttf",
    url: "MINIONPRO-IT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-MEDIUM ttf",
    url: "MINIONPRO-MEDIUM.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-MEDIUMIT ttf",
    url: "MINIONPRO-MEDIUMIT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MinionPro-Regular ttf",
    url: "MinionPro-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-SEMIBOLD ttf",
    url: "MINIONPRO-SEMIBOLD.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MINIONPRO-SEMIBOLDIT ttf",
    url: "MINIONPRO-SEMIBOLDIT.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Miriam Fixed ttf",
    url: "Miriam Fixed.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Miriam ttf",
    url: "Miriam.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MOD20 TTF",
    url: "MOD20.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MODERNMTSTD-WIDE 2 TTF",
    url: "MODERNMTSTD-WIDE 2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MODERNMTSTD-WIDEITALIC 2 TTF",
    url: "MODERNMTSTD-WIDEITALIC 2.TTF",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "monbaiti ttf",
    url: "monbaiti.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Mongolian Baiti ttf",
    url: "Mongolian Baiti.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Monotype Imaging - Albertus MT Light ttf",
    url: "Monotype Imaging - Albertus MT Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Monteverdi Italic ttf",
    url: "Monteverdi Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Monteverdi SC ttf",
    url: "Monteverdi SC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Monteverdi ttf",
    url: "Monteverdi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "moolbor ttf",
    url: "moolbor.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MoolBoran ttf",
    url: "MoolBoran.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MREASOTR TTF",
    url: "MREASOTR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MRESOTRI TTF",
    url: "MRESOTRI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mriam ttf",
    url: "mriam.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mriamc ttf",
    url: "mriamc.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavAllSmaCap (2) ttf",
    url: "MrsEavAllSmaCap (2).ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesBold otf ttf",
    url: "MrsEavesBold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesFractions otf ttf",
    url: "MrsEavesFractions.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesItalic otf ttf",
    url: "MrsEavesItalic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesPetiteCaps otf ttf",
    url: "MrsEavesPetiteCaps.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesRoman otf ttf",
    url: "MrsEavesRoman.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavesSmallCaps otf ttf",
    url: "MrsEavesSmallCaps.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MrsEavIta ttf",
    url: "MrsEavIta.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MS Gothic ttc",
    url: "MS Gothic.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MS PMincho ttc",
    url: "MS PMincho.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msgothic ttc",
    url: "msgothic.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msjh ttf",
    url: "msjh.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msjhbd ttf",
    url: "msjhbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msmincho ttc",
    url: "msmincho.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msuighur ttf",
    url: "msuighur.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msyh ttf",
    url: "msyh.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msyhbd ttf",
    url: "msyhbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "msyi ttf",
    url: "msyi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-100 ttf",
    url: "MuseoSans-100.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-100Italic ttf",
    url: "MuseoSans-100Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-300 ttf",
    url: "MuseoSans-300.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-300Italic ttf",
    url: "MuseoSans-300Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-500 ttf",
    url: "MuseoSans-500.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-500Italic ttf",
    url: "MuseoSans-500Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-700 ttf",
    url: "MuseoSans-700.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-700Italic ttf",
    url: "MuseoSans-700Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-900 ttf",
    url: "MuseoSans-900.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSans-900Italic ttf",
    url: "MuseoSans-900Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSlab-Bold ttf",
    url: "MuseoSlab-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSlab-BoldItalic ttf",
    url: "MuseoSlab-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSlab-Italic ttf",
    url: "MuseoSlab-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "MuseoSlab-Regular ttf",
    url: "MuseoSlab-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MV Boli ttf",
    url: "MV Boli.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "mvboli ttf",
    url: "mvboli.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIADPB TTF",
    url: "MYRIADPB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIADPC TTF",
    url: "MYRIADPC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIADPI TTF",
    url: "MYRIADPI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIADPR TTF",
    url: "MYRIADPR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MyriadPro-Regular ttf",
    url: "MyriadPro-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIADPS TTF",
    url: "MYRIADPS.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIAPBC TTF",
    url: "MYRIAPBC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIAPBI TTF",
    url: "MYRIAPBI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIAPCI TTF",
    url: "MYRIAPCI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIAPSI TTF",
    url: "MYRIAPSI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "MYRIPBCI TTF",
    url: "MYRIPBCI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NanumMyeongjo ttf",
    url: "NanumMyeongjo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NanumMyeongjoBold ttf",
    url: "NanumMyeongjoBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NanumMyeongjoExtraBold ttf",
    url: "NanumMyeongjoExtraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Narkisim ttf",
    url: "Narkisim.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Bold otf ttf",
    url: "NeutraDisplay-Bold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-BoldAlt otf ttf",
    url: "NeutraDisplay-BoldAlt.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Draft otf ttf",
    url: "NeutraDisplay-Draft.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-DraftAlt otf ttf",
    url: "NeutraDisplay-DraftAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Light otf ttf",
    url: "NeutraDisplay-Light.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-LightAlt otf ttf",
    url: "NeutraDisplay-LightAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Medium otf ttf",
    url: "NeutraDisplay-Medium.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-MediumAlt otf ttf",
    url: "NeutraDisplay-MediumAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Num otf ttf",
    url: "NeutraDisplay-Num.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-NumAlt otf ttf",
    url: "NeutraDisplay-NumAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Thin otf ttf",
    url: "NeutraDisplay-Thin.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-ThinAlt otf ttf",
    url: "NeutraDisplay-ThinAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraDisplay-Titling otf ttf",
    url: "NeutraDisplay-Titling.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Neutraface Text Demi ttf",
    url: "Neutraface Text Demi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText_Book ttf",
    url: "NeutraText_Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText_LightItalic ttf",
    url: "NeutraText_LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-Bold otf ttf",
    url: "NeutraText-Bold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BoldAlt otf ttf",
    url: "NeutraText-BoldAlt.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BoldItalic otf ttf",
    url: "NeutraText-BoldItalic.otf.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BoldItalicAlt otf ttf",
    url: "NeutraText-BoldItalicAlt.otf.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-Book otf ttf",
    url: "NeutraText-Book.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BookAlt otf ttf",
    url: "NeutraText-BookAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BookItalic otf ttf",
    url: "NeutraText-BookItalic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-BookItalicAlt otf ttf",
    url: "NeutraText-BookItalicAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-Demi otf ttf",
    url: "NeutraText-Demi.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-DemiAlt otf ttf",
    url: "NeutraText-DemiAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-DemiItalic otf ttf",
    url: "NeutraText-DemiItalic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-DemiItalicAlt otf ttf",
    url: "NeutraText-DemiItalicAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-Light otf ttf",
    url: "NeutraText-Light.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-LightAlt otf ttf",
    url: "NeutraText-LightAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-LightItalAlt otf ttf",
    url: "NeutraText-LightItalAlt.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NeutraText-LightItalic otf ttf",
    url: "NeutraText-LightItalic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "nrkis ttf",
    url: "nrkis.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "NSimSun ttc",
    url: "NSimSun.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ntailu ttf",
    url: "ntailu.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ntailub ttf",
    url: "ntailub.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "nyala ttf",
    url: "nyala.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Optima LT Roman ttf",
    url: "Optima LT Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Optima-Bold ttf",
    url: "Optima-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Optima-BoldItalic ttf",
    url: "Optima-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Optima-ExtraBlack ttf",
    url: "Optima-ExtraBlack.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Optima-Italic ttf",
    url: "Optima-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Optima-Regular ttf",
    url: "Optima-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "p22-underground ttf",
    url: "p22-underground.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "P22Eaglefeather ttf",
    url: "P22Eaglefeather.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "P22EaglefeatherBold ttf",
    url: "P22EaglefeatherBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "P22EaglefeatherBoldItalic ttf",
    url: "P22EaglefeatherBoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "P22EaglefeatherItalic ttf",
    url: "P22EaglefeatherItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "pala ttf",
    url: "pala.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "palab ttf",
    url: "palab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "palabi ttf",
    url: "palabi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "palai ttf",
    url: "palai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Palatino Linotype Bold Italic ttf",
    url: "Palatino Linotype Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Palatino Linotype Bold ttf",
    url: "Palatino Linotype Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Palatino Linotype Italic ttf",
    url: "Palatino Linotype Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Palatino Linotype ttf",
    url: "Palatino Linotype.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Parisian Normal ttf",
    url: "Parisian Normal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Parisian BT ttf",
    url: "Parisian BT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "pee pee pants ttf",
    url: "pee pee pants.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua Bold Italic ttf",
    url: "Perpetua Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua Bold ttf",
    url: "Perpetua Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua Expert ttf",
    url: "Perpetua Expert.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua Italic ttf",
    url: "Perpetua Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua SC ttf",
    url: "Perpetua SC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Perpetua ttf",
    url: "Perpetua.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "PFEef-Regular ttf",
    url: "PFEef-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "phagspa ttf",
    url: "phagspa.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "phagspab ttf",
    url: "phagspab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantagenet Cherokee ttf",
    url: "Plantagenet Cherokee.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "plantc ttf",
    url: "plantc.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Head MT Std Bold Cn ttf",
    url: "Plantin Head MT Std Bold Cn.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Head MT Std Light Cn ttf",
    url: "Plantin Head MT Std Light Cn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Head MT Std Medium Cn ttf",
    url: "Plantin Head MT Std Medium Cn.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Infant MT Std Bold It ttf",
    url: "Plantin Infant MT Std Bold It.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Infant MT Std Bold ttf",
    url: "Plantin Infant MT Std Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Infant MT Std Italic ttf",
    url: "Plantin Infant MT Std Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Infant MT Std ttf",
    url: "Plantin Infant MT Std.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Bold Italic ttf",
    url: "Plantin MT Std Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Bold ttf",
    url: "Plantin MT Std Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Italic ttf",
    url: "Plantin MT Std Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Light Italic ttf",
    url: "Plantin MT Std Light Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Light ttf",
    url: "Plantin MT Std Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Semibold Italic ttf",
    url: "Plantin MT Std Semibold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std Semibold ttf",
    url: "Plantin MT Std Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin MT Std ttf",
    url: "Plantin MT Std.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Std Bold Condensed ttf",
    url: "Plantin Std Bold Condensed.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Plantin Titling MT Std ttf",
    url: "Plantin Titling MT Std.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Prata-Regular ttf",
    url: "Prata-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Quicksand_Dash ttf",
    url: "Quicksand_Dash.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "raavi ttf",
    url: "raavi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "raavib ttf",
    url: "raavib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-Bold ttf",
    url: "Raleway-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-ExtraBold ttf",
    url: "Raleway-ExtraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-ExtraLight ttf",
    url: "Raleway-ExtraLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-Heavy ttf",
    url: "Raleway-Heavy.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-Light ttf",
    url: "Raleway-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-Medium ttf",
    url: "Raleway-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-SemiBold ttf",
    url: "Raleway-SemiBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway-Thin ttf",
    url: "Raleway-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Raleway ttf",
    url: "Raleway.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "REQUIDSC TTF",
    url: "REQUIDSC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "REQUITSC TTF",
    url: "REQUITSC.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RobotoSlab-Bold ttf",
    url: "RobotoSlab-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RobotoSlab-Light ttf",
    url: "RobotoSlab-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RobotoSlab-Regular ttf",
    url: "RobotoSlab-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RobotoSlab-Thin ttf",
    url: "RobotoSlab-Thin.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-Bold ttf",
    url: "RockwellStd-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-BoldCondensed ttf",
    url: "RockwellStd-BoldCondensed.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-BoldItalic ttf",
    url: "RockwellStd-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-Condensed ttf",
    url: "RockwellStd-Condensed.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-ExtraBold ttf",
    url: "RockwellStd-ExtraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-Italic ttf",
    url: "RockwellStd-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-Light ttf",
    url: "RockwellStd-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd-LightItalic ttf",
    url: "RockwellStd-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "RockwellStd ttf",
    url: "RockwellStd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "rod ttf",
    url: "rod.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "RosewoodStd-Regular otf",
    url: "RosewoodStd-Regular.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Sabon LT Std Bold Italic ttf",
    url: "Sabon LT Std Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Sabon LT Std Bold ttf",
    url: "Sabon LT Std Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sabon LT Std Italic ttf",
    url: "Sabon LT Std Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Sabon LT Std Roman ttf",
    url: "Sabon LT Std Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SACKEGSH TTF",
    url: "SACKEGSH.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SACKEGSL TTF",
    url: "SACKEGSL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sackers Gothic Medium Alt ttf",
    url: "Sackers Gothic Medium Alt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sackers Gothic Medium ttf",
    url: "Sackers Gothic Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SackersGothicMedium-Oblique ttf",
    url: "SackersGothicMedium-Oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SackersGothicStd_Light ttf",
    url: "SackersGothicStd_Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SackersGothicStd-Heavy ttf",
    url: "SackersGothicStd-Heavy.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SACKERSH TTF",
    url: "SACKERSH.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SackersRomanStd-Heavy otf",
    url: "SackersRomanStd-Heavy.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "SaganReg ttf",
    url: "SaganReg.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SaisonsSmartFont ttf",
    url: "SaisonsSmartFont.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SangBleuSans-Bold ttf",
    url: "SangBleuSans-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SangBleuSans-Medium ttf",
    url: "SangBleuSans-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SangBleuSans-Regular ttf",
    url: "SangBleuSans-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SangBleuSans-RegularItalic ttf",
    url: "SangBleuSans-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Sansumi-Bold ttf",
    url: "Sansumi-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sansumi-Regular ttf",
    url: "Sansumi-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sansumi-UltraLight ttf",
    url: "Sansumi-UltraLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Scala-Bold otf ttf",
    url: "Scala-Bold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Scala-BoldItalic otf ttf",
    url: "Scala-BoldItalic.otf.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Scala-Italic otf ttf",
    url: "Scala-Italic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Scala otf ttf",
    url: "Scala.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ScalaCaps-Bold otf ttf",
    url: "ScalaCaps-Bold.otf.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ScalaCaps-BoldItalic otf ttf",
    url: "ScalaCaps-BoldItalic.otf.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ScalaCaps-Italic otf ttf",
    url: "ScalaCaps-Italic.otf.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "ScalaCaps otf ttf",
    url: "ScalaCaps.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe Print Bold ttf",
    url: "Segoe Print Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe Print ttf",
    url: "Segoe Print.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe Script Bold ttf",
    url: "Segoe Script Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe Script ttf",
    url: "Segoe Script.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe UI Bold Italic ttf",
    url: "Segoe UI Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Segoe UI Bold ttf",
    url: "Segoe UI Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Segoe UI Italic ttf",
    url: "Segoe UI Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Segoe UI ttf",
    url: "Segoe UI.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoepr ttf",
    url: "segoepr.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeprb ttf",
    url: "segoeprb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoesc ttf",
    url: "segoesc.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoescb ttf",
    url: "segoescb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeui ttf",
    url: "segoeui.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeuib ttf",
    url: "segoeuib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeuii ttf",
    url: "segoeuii.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeuil ttf",
    url: "segoeuil.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "segoeuiz ttf",
    url: "segoeuiz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "seguisb ttf",
    url: "seguisb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "seguisym ttf",
    url: "seguisym.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-Bold ttf",
    url: "Seravek-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-BoldItalic ttf",
    url: "Seravek-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-ExtraLight ttf",
    url: "Seravek-ExtraLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-ExtraLightItalic ttf",
    url: "Seravek-ExtraLightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-Italic ttf",
    url: "Seravek-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-Light ttf",
    url: "Seravek-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-LightItalic ttf",
    url: "Seravek-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-Medium ttf",
    url: "Seravek-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Seravek-MediumItalic ttf",
    url: "Seravek-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Seravek ttf",
    url: "Seravek.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Sheila otf ttf",
    url: "Sheila.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SheilaB otf ttf",
    url: "SheilaB.otf.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Shonar ttf",
    url: "Shonar.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Shonarb ttf",
    url: "Shonarb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "shruti ttf",
    url: "shruti.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "shrutib ttf",
    url: "shrutib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simfang ttf",
    url: "simfang.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simhei ttf",
    url: "simhei.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simkai ttf",
    url: "simkai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simpbdo ttf",
    url: "simpbdo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simpfxo ttf",
    url: "simpfxo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Simplified Arabic Bold ttf",
    url: "Simplified Arabic Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Simplified Arabic Fixed ttf",
    url: "Simplified Arabic Fixed.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Simplified Arabic ttf",
    url: "Simplified Arabic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simpo ttf",
    url: "simpo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SimSun-ExtB ttf",
    url: "SimSun-ExtB.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simsun ttc",
    url: "simsun.ttc",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "simsunb ttf",
    url: "simsunb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Snell Roundhand Black ttf",
    url: "Snell Roundhand Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Snell Roundhand Bold ttf",
    url: "Snell Roundhand Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Snell Roundhand ttf",
    url: "Snell Roundhand.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SpecialElite-Bold ttf",
    url: "SpecialElite-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SpecialElite ttf",
    url: "SpecialElite.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Stratum1_Medium ttf",
    url: "Stratum1_Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Stratum1_Regular ttf",
    url: "Stratum1_Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Stratum2_Light ttf",
    url: "Stratum2_Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Stratum2_Medium ttf",
    url: "Stratum2_Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Black-Italic ttf",
    url: "Superior-Title-Black-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Black ttf",
    url: "Superior-Title-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Bold-Italic ttf",
    url: "Superior-Title-Bold-Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Bold ttf",
    url: "Superior-Title-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Light-Italic ttf",
    url: "Superior-Title-Light-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Light ttf",
    url: "Superior-Title-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Medium-Italic ttf",
    url: "Superior-Title-Medium-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Medium ttf",
    url: "Superior-Title-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Regular-Italic ttf",
    url: "Superior-Title-Regular-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Superior-Title-Regular ttf",
    url: "Superior-Title-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BT1 TTF",
    url: "SW721BT1.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BT2 TTF",
    url: "SW721BT2.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BT3 TTF",
    url: "SW721BT3.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BTB TTF",
    url: "SW721BTB.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BTI TTF",
    url: "SW721BTI.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BTL TTF",
    url: "SW721BTL.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "SW721BTR TTF",
    url: "SW721BTR.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-black-condensed-bt ttf",
    url: "swiss-721-black-condensed-bt.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-bold-bt-70711 ttf",
    url: "swiss-721-bold-bt-70711.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-bold-condensed-bt-70602 ttf",
    url: "swiss-721-bold-condensed-bt-70602.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-bt-70631 ttf",
    url: "swiss-721-bt-70631.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-condensed-bt-70648 ttf",
    url: "swiss-721-condensed-bt-70648.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-condensed-italic-bt ttf",
    url: "swiss-721-condensed-italic-bt.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-italic-bt ttf",
    url: "swiss-721-italic-bt.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "swiss-721-light-condensed-bt-70590 ttf",
    url: "swiss-721-light-condensed-bt-70590.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Swiss721BT-BlackCondensed otf",
    url: "Swiss721BT-BlackCondensed.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-Bold otf",
    url: "Swiss721BT-Bold.otf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-BoldCondensed otf",
    url: "Swiss721BT-BoldCondensed.otf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-Italic otf",
    url: "Swiss721BT-Italic.otf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-LightCondensed otf",
    url: "Swiss721BT-LightCondensed.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-Roman otf",
    url: "Swiss721BT-Roman.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "Swiss721BT-RomanCondensed otf",
    url: "Swiss721BT-RomanCondensed.otf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "opentype",
  },
  {
    fontFamily: "sylfaen ttf",
    url: "sylfaen.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "symbol ttf",
    url: "symbol.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Tahoma Bold ttf",
    url: "Tahoma Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "tahoma ttf",
    url: "tahoma.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "tahomabd ttf",
    url: "tahomabd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "taile ttf",
    url: "taile.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "taileb ttf",
    url: "taileb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "TheanoOldStyle-Regular ttf",
    url: "TheanoOldStyle-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ThrowMyHandsUpintheAir ttf",
    url: "ThrowMyHandsUpintheAir.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ThrowMyHandsUpintheAirBold ttf",
    url: "ThrowMyHandsUpintheAirBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Tiempos-Text-Regular-Italic ttf",
    url: "Tiempos-Text-Regular-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Tiempos-Text-Regular ttf",
    url: "Tiempos-Text-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Times Bold Italic ttf",
    url: "Times Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Times Bold ttf",
    url: "Times Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Times Italic ttf",
    url: "Times Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Times New Roman Bold Italic ttf",
    url: "Times New Roman Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Times New Roman Bold ttf",
    url: "Times New Roman Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Times New Roman Italic ttf",
    url: "Times New Roman Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Times New Roman ttf",
    url: "Times New Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Times Roman ttf",
    url: "Times Roman.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "times ttf",
    url: "times.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "timesbd ttf",
    url: "timesbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "timesbi ttf",
    url: "timesbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "timesi ttf",
    url: "timesi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "tradbdo ttf",
    url: "tradbdo.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Trade_Gothic_LT_Std_Bold_Extended ttf",
    url: "Trade_Gothic_LT_Std_Bold_Extended.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trade-gothic-lt-light-oblique ttf",
    url: "trade-gothic-lt-light-oblique.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "TradeGothicLTStd ttf",
    url: "TradeGothicLTStd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Traditional Arabic Bold ttf",
    url: "Traditional Arabic Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Traditional Arabic ttf",
    url: "Traditional Arabic.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trado ttf",
    url: "trado.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trebuc ttf",
    url: "trebuc.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trebucbd ttf",
    url: "trebucbd.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trebucbi ttf",
    url: "trebucbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Trebuchet MS Bold Italic ttf",
    url: "Trebuchet MS Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Trebuchet MS Bold ttf",
    url: "Trebuchet MS Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Trebuchet MS Italic ttf",
    url: "Trebuchet MS Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Trebuchet MS ttf",
    url: "Trebuchet MS.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "trebucit ttf",
    url: "trebucit.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "tunga ttf",
    url: "tunga.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "tungab ttf",
    url: "tungab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Tungsten-Narrow-Medium ttf",
    url: "Tungsten-Narrow-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Tungsten-Semibold ttf",
    url: "Tungsten-Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "ufonts com_bauer-bodoni-black.ttf",
    url: "ufonts.com_bauer-bodoni-black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UnderwoodChampion ttf",
    url: "UnderwoodChampion.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Univers-ThinUltraCondensed ttf",
    url: "Univers-ThinUltraCondensed.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Univers-UltraCondensed ttf",
    url: "Univers-UltraCondensed.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-Black ttf",
    url: "UntitledSans-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-BlackItalic ttf",
    url: "UntitledSans-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-Bold ttf",
    url: "UntitledSans-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-BoldItalic ttf",
    url: "UntitledSans-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-Light ttf",
    url: "UntitledSans-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-LightItalic ttf",
    url: "UntitledSans-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-Medium ttf",
    url: "UntitledSans-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-MediumItalic ttf",
    url: "UntitledSans-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-Regular ttf",
    url: "UntitledSans-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSans-RegularItalic ttf",
    url: "UntitledSans-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-Bold ttf",
    url: "UntitledSerif-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-BoldItalic ttf",
    url: "UntitledSerif-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-Medium ttf",
    url: "UntitledSerif-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-MediumItalic ttf",
    url: "UntitledSerif-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-Regular ttf",
    url: "UntitledSerif-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "UntitledSerif-RegularItalic ttf",
    url: "UntitledSerif-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "upcdb ttf",
    url: "upcdb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcdbi ttf",
    url: "upcdbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcdi ttf",
    url: "upcdi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcdl ttf",
    url: "upcdl.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upceb ttf",
    url: "upceb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcebi ttf",
    url: "upcebi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcei ttf",
    url: "upcei.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcel ttf",
    url: "upcel.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcfb ttf",
    url: "upcfb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcfbi ttf",
    url: "upcfbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcfi ttf",
    url: "upcfi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcfl ttf",
    url: "upcfl.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcib ttf",
    url: "upcib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcibi ttf",
    url: "upcibi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcii ttf",
    url: "upcii.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcil ttf",
    url: "upcil.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcjb ttf",
    url: "upcjb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcjbi ttf",
    url: "upcjbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcji ttf",
    url: "upcji.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcjl ttf",
    url: "upcjl.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upckb ttf",
    url: "upckb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upckbi ttf",
    url: "upckbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcki ttf",
    url: "upcki.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upckl ttf",
    url: "upckl.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upclb ttf",
    url: "upclb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upclbi ttf",
    url: "upclbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcli ttf",
    url: "upcli.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "upcll ttf",
    url: "upcll.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "utsaah ttf",
    url: "utsaah.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "utsaahb ttf",
    url: "utsaahb.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "utsaahbi ttf",
    url: "utsaahbi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "utsaahi ttf",
    url: "utsaahi.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VanDijckMT ttf",
    url: "VanDijckMT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VanDijckMTStd-Italic ttf",
    url: "VanDijckMTStd-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Vani ttf",
    url: "Vani.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Vanib ttf",
    url: "Vanib.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDBOLD",
    url: "VENDBOLD.TTF",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEIT print",
    url: "VENDMEIT.PFB",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEIT print metric",
    url: "VENDMEIT.PFM",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEIT",
    url: "VENDMEIT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEPC print",
    url: "VENDMEPC.PFB",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEPC print metric",
    url: "VENDMEPC.PFM",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VENDMEPC",
    url: "VENDMEPC.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verdana Bold Italic ttf",
    url: "Verdana Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verdana Bold ttf",
    url: "Verdana Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verdana Italic ttf",
    url: "Verdana Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "verdana ttf",
    url: "verdana.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "verdanab ttf",
    url: "verdanab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "verdanai ttf",
    url: "verdanai.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "verdanaz ttf",
    url: "verdanaz.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Black Italic ttf",
    url: "Verlag Black Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Black ttf",
    url: "Verlag Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Bold Italic ttf",
    url: "Verlag Bold Italic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Bold ttf",
    url: "Verlag Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Book Italic ttf",
    url: "Verlag Book Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Book ttf",
    url: "Verlag Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Extra Light Italic ttf",
    url: "Verlag Extra Light Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Extra Light ttf",
    url: "Verlag Extra Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Light Italic ttf",
    url: "Verlag Light Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Verlag Light ttf",
    url: "Verlag Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "vijaya ttf",
    url: "vijaya.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "vijayab ttf",
    url: "vijayab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "vistasanslight ttf",
    url: "vistasanslight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VistaSansSCLight ttf",
    url: "VistaSansSCLight.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Vogue-Normal ttf",
    url: "Vogue-Normal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VOGUEN TTF",
    url: "VOGUEN.TTF",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "vrinda ttf",
    url: "vrinda.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "vrindab ttf",
    url: "vrindab.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_BlickElectricCursive ttf",
    url: "VTypewriter_BlickElectricCursive.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_Corona ttf",
    url: "VTypewriter_Corona.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_RemingtonPortable ttf",
    url: "VTypewriter_RemingtonPortable.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_RibbonFace ttf",
    url: "VTypewriter_RibbonFace.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_Royal ttf",
    url: "VTypewriter_Royal.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_RoyalElite ttf",
    url: "VTypewriter_RoyalElite.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "VTypewriter_UnderwoodPortable ttf",
    url: "VTypewriter_UnderwoodPortable.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Walbaum MT Std-Italic ttf",
    url: "Walbaum MT Std-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Walbaum MT Std-Regular ttf",
    url: "Walbaum MT Std-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-Bold ttf",
    url: "WalbaumBook-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-BoldItalic ttf",
    url: "WalbaumBook-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-Italic ttf",
    url: "WalbaumBook-Italic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-Medium ttf",
    url: "WalbaumBook-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-MediumItalic ttf",
    url: "WalbaumBook-MediumItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "WalbaumBook-Regular ttf",
    url: "WalbaumBook-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Walkway Black ttf",
    url: "Walkway Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Walkway Bold ttf",
    url: "Walkway Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Walkway SemiBold ttf",
    url: "Walkway SemiBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Walkway UltraBold ttf",
    url: "Walkway UltraBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "webdings ttf",
    url: "webdings.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Whitney-Medium ttf",
    url: "Whitney-Medium.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Whitney-Semibold ttf",
    url: "Whitney-Semibold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "wingding ttf",
    url: "wingding.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Wingdings ttf",
    url: "Wingdings.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-Black ttf",
    url: "Yport-Black.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-BlackItalic ttf",
    url: "Yport-BlackItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Yport-Bold ttf",
    url: "Yport-Bold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-BoldItalic ttf",
    url: "Yport-BoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Yport-Book ttf",
    url: "Yport-Book.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-BookItalic ttf",
    url: "Yport-BookItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Yport-Light ttf",
    url: "Yport-Light.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-LightItalic ttf",
    url: "Yport-LightItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Yport-Regular ttf",
    url: "Yport-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-RegularItalic ttf",
    url: "Yport-RegularItalic.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "Yport-SemiBold ttf",
    url: "Yport-SemiBold.ttf",
    fontWeight: "bold",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Yport-SemiBoldItalic ttf",
    url: "Yport-SemiBoldItalic.ttf",
    fontWeight: "bold",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "YportVariableItalic-Regular ttf",
    url: "YportVariableItalic-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "italic",
    format: "truetype",
  },
  {
    fontFamily: "YportVariableUpright-Regular ttf",
    url: "YportVariableUpright-Regular.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
  {
    fontFamily: "Zapf Humanist 601 BT ttf",
    url: "Zapf Humanist 601 BT.ttf",
    fontWeight: "normal",
    fontStyle: "normal",
    format: "truetype",
  },
];

export const DEFAULT_SELECTION = {
  font: "Libre Baskerville",
  primaryColor: "#000",
  secondaryColor: "#fff",
  tertiaryColor: "#6C757D",
  quaternary: "#7B2133",
};

export const CIRCLE_COLORS = [
  "#E44C32",
  "#E8843B",
  "#F1CA4B",
  "#77EFCF",
  "#53A8F2",
  "#6C6CF2",
];

export const COMPACT_COLORS = [
  "#4D4D4D",
  "#999999",
  "#FFFFFF",
  "#F44E3B",
  "#FE9200",
  "#FCDC00",
  "#DBDF00",
  "#A4DD00",
  "#68CCCA",
  "#73D8FF",
  "#AEA1FF",
  "#FDA1FF",
  "#333333",
  "#808080",
  "#cccccc",
  "#D33115",
  "#E27300",
  "#FCC400",
  "#B0BC00",
  "#68BC00",
  "#16A5A5",
  "#009CE0",
  "#7B64FF",
  "#FA28FF",
  "#000000",
  "#666666",
  "#6C757D",
  "#7B2133",
  "#C45100",
  "#FB9E00",
  "#808900",
  "#194D33",
  "#0C797D",
  "#0062B1",
  "#653294",
  "#AB149E",
];

export const IMAGES = {
  APP_LOGO: require("./Assets/Images/sprout-qr-logo.png"),
  APP_DEFAULT_BACKGROUND: require("./Assets/Images/wine-bg.jpg"),
  ONBOARDING_LOGO: require("./Assets/Images/onboarding-logo.png"),
  ONBOARDING_LOGO_MOBILE: require("./Assets/Images/onboarding-logo-mobile.png"),
  ONBOARDING_TOGGLE_ICON: require("./Assets/Images/onboarding-toggle.png"),
  STRIPE_LOGO: require("./Assets/Images/stripe-logo.png"),
  CLOSE_ICON: require("./Assets/Images/close.png"),
  DOWNLOAD_ICON: require("./Assets/Images/download.png"),
  PLUS_ICON: require("./Assets/Images/plus.png"),
};

export const AUTH_ERROR_MESSAGES = {
  InvalidParameterException: "Invalid account. Please try again.",
  UserNotFoundException: "Not found account. Please use another account.",
  NotAuthorizedException: "Incorrect username or password.",
  signInDefault: "Sign in fail. Please try again.",
  UsernameExistsException: "An account with the given email already exists.",
  UserNotConfirmedException: "Please verify your account!",
};

export const PHONE_COUNTRY_CODES = [
  "+1",
  "+7",
  "+20",
  "+27",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+36",
  "+39",
  "+40",
  "+41",
  "+43",
  "+44",
  "+45",
  "+46",
  "+47",
  "+48",
  "+49",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+81",
  "+82",
  "+84",
  "+86",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+98",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+290",
  "+291",
  "+297",
  "+298",
  "+299",
  "+345",
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+379",
  "+380",
  "+381",
  "+382",
  "+385",
  "+386",
  "+387",
  "+389",
  "+420",
  "+421",
  "+423",
  "+500",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+537",
  "+590",
  "+591",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+599",
  "+670",
  "+672",
  "+673",
  "+674",
  "+675",
  "+676",
  "+677",
  "+678",
  "+679",
  "+680",
  "+681",
  "+682",
  "+683",
  "+685",
  "+686",
  "+687",
  "+688",
  "+689",
  "+690",
  "+691",
  "+692",
  "+850",
  "+852",
  "+853",
  "+855",
  "+856",
  "+872",
  "+880",
  "+886",
  "+960",
  "+961",
  "+962",
  "+963",
  "+964",
  "+965",
  "+966",
  "+967",
  "+968",
  "+970",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+992",
  "+993",
  "+994",
  "+995",
  "+996",
  "+998",
];

export const PLAN_CURRENCY = {
  usd: "$",
};
